"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSensorPageProductEnum = exports.GetSensorPageStatusEnum = exports.GetScannerPageTypeEnum = exports.GetScannerPageStatusEnum = exports.GetReportDataByQueryIDQueryIdEnum = exports.GetDetectionPageSortEnum = exports.GetDetectionPageSortByEnum = exports.GetDetectionPageCvesDetectionsEnum = exports.GetDetectionPageSeverityEnum = exports.GetDetectionPagePlatformEnum = exports.GetDetectionPageTechnologyEnum = exports.GetDetectionPageUseCaseEnum = exports.GetCloudSensorPageStatusEnum = exports.GetAgentPageV2OsTypeEnum = exports.GetAgentPageV2StatusEnum = exports.GetAgentModulesStatusEnum = exports.DownloadHyperVSensorSensorImageIdEnum = exports.CreateDetectionsExportSortEnum = exports.CreateDetectionsExportSortByEnum = exports.CreateDetectionsExportCvesDetectionsEnum = exports.CreateDetectionsExportSeverityEnum = exports.CreateDetectionsExportPlatformEnum = exports.CreateDetectionsExportTechnologyEnum = exports.CreateDetectionsExportUseCaseEnum = exports.DefaultApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Enable/Disable multiple agent Schedules
     */
    DefaultApi.prototype.bulkDisableAgentScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling bulkDisableAgentSchedule.');
                        }
                        if (requestParameters.manageAgentScheduleStateInput === null || requestParameters.manageAgentScheduleStateInput === undefined) {
                            throw new runtime.RequiredError('manageAgentScheduleStateInput', 'Required parameter requestParameters.manageAgentScheduleStateInput was null or undefined when calling bulkDisableAgentSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/scan-schedules".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ManageAgentScheduleStateInputToJSON)(requestParameters.manageAgentScheduleStateInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Enable/Disable multiple agent Schedules
     */
    DefaultApi.prototype.bulkDisableAgentSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkDisableAgentScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Disable multiple IVA Schedule
     */
    DefaultApi.prototype.bulkDisableIvaScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling bulkDisableIvaSchedule.');
                        }
                        if (requestParameters.manageIvaScheduleStateInputs === null || requestParameters.manageIvaScheduleStateInputs === undefined) {
                            throw new runtime.RequiredError('manageIvaScheduleStateInputs', 'Required parameter requestParameters.manageIvaScheduleStateInputs was null or undefined when calling bulkDisableIvaSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/scan-schedules/disable".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ManageIvaScheduleStateInputsToJSON)(requestParameters.manageIvaScheduleStateInputs),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Disable multiple IVA Schedule
     */
    DefaultApi.prototype.bulkDisableIvaSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkDisableIvaScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Enable/Disable multiple EVA Schedule
     */
    DefaultApi.prototype.bulkUpdateScanStatusEvaScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling bulkUpdateScanStatusEvaSchedule.');
                        }
                        if (requestParameters.manageEvaScheduleStateInput === null || requestParameters.manageEvaScheduleStateInput === undefined) {
                            throw new runtime.RequiredError('manageEvaScheduleStateInput', 'Required parameter requestParameters.manageEvaScheduleStateInput was null or undefined when calling bulkUpdateScanStatusEvaSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/eva/scan-schedules/toggle-disabled".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ManageEvaScheduleStateInputToJSON)(requestParameters.manageEvaScheduleStateInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Enable/Disable multiple EVA Schedule
     */
    DefaultApi.prototype.bulkUpdateScanStatusEvaSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkUpdateScanStatusEvaScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles the request to cancel multiple scans.
     * Handles the request to cancel multiple scans
     */
    DefaultApi.prototype.cancelAgentScansRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling cancelAgentScans.');
                        }
                        if (requestParameters.cancelAgentScansInput === null || requestParameters.cancelAgentScansInput === undefined) {
                            throw new runtime.RequiredError('cancelAgentScansInput', 'Required parameter requestParameters.cancelAgentScansInput was null or undefined when calling cancelAgentScans.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/cancel-scans".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CancelAgentScansInputToJSON)(requestParameters.cancelAgentScansInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Handles the request to cancel multiple scans.
     * Handles the request to cancel multiple scans
     */
    DefaultApi.prototype.cancelAgentScans = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelAgentScansRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles the request to cancel multiple scans.
     * Handles the request to cancel multiple scans
     */
    DefaultApi.prototype.cancelEvaScansRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling cancelEvaScans.');
                        }
                        if (requestParameters.cancelEvaScansInput === null || requestParameters.cancelEvaScansInput === undefined) {
                            throw new runtime.RequiredError('cancelEvaScansInput', 'Required parameter requestParameters.cancelEvaScansInput was null or undefined when calling cancelEvaScans.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/eva/cancel-scans".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CancelEvaScansInputToJSON)(requestParameters.cancelEvaScansInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Handles the request to cancel multiple scans.
     * Handles the request to cancel multiple scans
     */
    DefaultApi.prototype.cancelEvaScans = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelEvaScansRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles the request to cancel multiple scans.
     * Handles the request to cancel multiple scans
     */
    DefaultApi.prototype.cancelIvaScansRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling cancelIvaScans.');
                        }
                        if (requestParameters.cancelIvaScansInput === null || requestParameters.cancelIvaScansInput === undefined) {
                            throw new runtime.RequiredError('cancelIvaScansInput', 'Required parameter requestParameters.cancelIvaScansInput was null or undefined when calling cancelIvaScans.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/cancel-scans".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CancelIvaScansInputToJSON)(requestParameters.cancelIvaScansInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Handles the request to cancel multiple scans.
     * Handles the request to cancel multiple scans
     */
    DefaultApi.prototype.cancelIvaScans = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelIvaScansRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Churn an agent, forcing a remote uninstall
     */
    DefaultApi.prototype.churnAgentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling churnAgent.');
                        }
                        if (requestParameters.agentId === null || requestParameters.agentId === undefined) {
                            throw new runtime.RequiredError('agentId', 'Required parameter requestParameters.agentId was null or undefined when calling churnAgent.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agents/{agentId}/churn-deactivate".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("agentId", "}"), encodeURIComponent(String(requestParameters.agentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Churn an agent, forcing a remote uninstall
     */
    DefaultApi.prototype.churnAgent = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.churnAgentRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a scan schedule for Agent
     */
    DefaultApi.prototype.createAgentScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAgentSchedule.');
                        }
                        if (requestParameters.agentScheduleInput === null || requestParameters.agentScheduleInput === undefined) {
                            throw new runtime.RequiredError('agentScheduleInput', 'Required parameter requestParameters.agentScheduleInput was null or undefined when calling createAgentSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/agent".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.AgentScheduleInputToJSON)(requestParameters.agentScheduleInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a scan schedule for Agent
     */
    DefaultApi.prototype.createAgentSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAgentScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create new cloud sensor
     */
    DefaultApi.prototype.createCloudSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createCloudSensor.');
                        }
                        if (requestParameters.createCloudSensorInput === null || requestParameters.createCloudSensorInput === undefined) {
                            throw new runtime.RequiredError('createCloudSensorInput', 'Required parameter requestParameters.createCloudSensorInput was null or undefined when calling createCloudSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/cloud-sensors".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateCloudSensorInputToJSON)(requestParameters.createCloudSensorInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CredentialFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create new cloud sensor
     */
    DefaultApi.prototype.createCloudSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCloudSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets and filters detections by various parameters returning as file in CSV format
     */
    DefaultApi.prototype.createDetectionsExportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.searchString !== undefined) {
                            queryParameters['searchString'] = requestParameters.searchString;
                        }
                        if (requestParameters.useCase !== undefined) {
                            queryParameters['useCase'] = requestParameters.useCase;
                        }
                        if (requestParameters.technology) {
                            queryParameters['technology'] = requestParameters.technology;
                        }
                        if (requestParameters.platform) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        if (requestParameters.severity) {
                            queryParameters['severity'] = requestParameters.severity;
                        }
                        if (requestParameters.cvesDetections !== undefined) {
                            queryParameters['cvesDetections'] = requestParameters.cvesDetections;
                        }
                        if (requestParameters.applications) {
                            queryParameters['applications'] = requestParameters.applications;
                        }
                        if (requestParameters.firstPublishedStart !== undefined) {
                            queryParameters['firstPublishedStart'] = requestParameters.firstPublishedStart.toISOString();
                        }
                        if (requestParameters.firstPublishedEnd !== undefined) {
                            queryParameters['firstPublishedEnd'] = requestParameters.firstPublishedEnd.toISOString();
                        }
                        if (requestParameters.lastModifiedStart !== undefined) {
                            queryParameters['lastModifiedStart'] = requestParameters.lastModifiedStart.toISOString();
                        }
                        if (requestParameters.lastModifiedEnd !== undefined) {
                            queryParameters['lastModifiedEnd'] = requestParameters.lastModifiedEnd.toISOString();
                        }
                        if (requestParameters.sortBy !== undefined) {
                            queryParameters['sortBy'] = requestParameters.sortBy;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/detections/export",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DetectionsExportDownloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets and filters detections by various parameters returning as file in CSV format
     */
    DefaultApi.prototype.createDetectionsExport = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDetectionsExportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create new EVA schedule
     */
    DefaultApi.prototype.createEvaScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createEvaSchedule.');
                        }
                        if (requestParameters.evaScheduleCreate === null || requestParameters.evaScheduleCreate === undefined) {
                            throw new runtime.RequiredError('evaScheduleCreate', 'Required parameter requestParameters.evaScheduleCreate was null or undefined when calling createEvaSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/eva".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.EvaScheduleCreateToJSON)(requestParameters.evaScheduleCreate),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create new EVA schedule
     */
    DefaultApi.prototype.createEvaSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createEvaScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a scan credentials for Iva
     */
    DefaultApi.prototype.createIvaCredentialScanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createIvaCredentialScan.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling createIvaCredentialScan.');
                        }
                        if (requestParameters.credentialInput === null || requestParameters.credentialInput === undefined) {
                            throw new runtime.RequiredError('credentialInput', 'Required parameter requestParameters.credentialInput was null or undefined when calling createIvaCredentialScan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-credentials".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CredentialInputToJSON)(requestParameters.credentialInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a scan credentials for Iva
     */
    DefaultApi.prototype.createIvaCredentialScan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createIvaCredentialScanRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a scan schedule for Iva
     */
    DefaultApi.prototype.createIvaScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createIvaSchedule.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling createIvaSchedule.');
                        }
                        if (requestParameters.ivaScheduleInput === null || requestParameters.ivaScheduleInput === undefined) {
                            throw new runtime.RequiredError('ivaScheduleInput', 'Required parameter requestParameters.ivaScheduleInput was null or undefined when calling createIvaSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-schedules".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.IvaScheduleInputToJSON)(requestParameters.ivaScheduleInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a scan schedule for Iva
     */
    DefaultApi.prototype.createIvaSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createIvaScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * initiate a new export for the given log search
     */
    DefaultApi.prototype.createLogSearchExportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createLogSearchExport.');
                        }
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling createLogSearchExport.');
                        }
                        if (requestParameters.logSearchExportInput === null || requestParameters.logSearchExportInput === undefined) {
                            throw new runtime.RequiredError('logSearchExportInput', 'Required parameter requestParameters.logSearchExportInput was null or undefined when calling createLogSearchExport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/{requestId}/exports".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters.requestId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.LogSearchExportInputToJSON)(requestParameters.logSearchExportInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogSearchExportFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * initiate a new export for the given log search
     */
    DefaultApi.prototype.createLogSearchExport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createLogSearchExportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create a new log search request
     */
    DefaultApi.prototype.createLogSearchRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createLogSearchRequest.');
                        }
                        if (requestParameters.logSearchRequestInput === null || requestParameters.logSearchRequestInput === undefined) {
                            throw new runtime.RequiredError('logSearchRequestInput', 'Required parameter requestParameters.logSearchRequestInput was null or undefined when calling createLogSearchRequest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.LogSearchRequestInputToJSON)(requestParameters.logSearchRequestInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogSearchRequestFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * create a new log search request
     */
    DefaultApi.prototype.createLogSearchRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createLogSearchRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add a tag to one or more log sources
     */
    DefaultApi.prototype.createLogSourceTagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createLogSourceTag.');
                        }
                        if (requestParameters.logSourceTagInput === null || requestParameters.logSourceTagInput === undefined) {
                            throw new runtime.RequiredError('logSourceTagInput', 'Required parameter requestParameters.logSourceTagInput was null or undefined when calling createLogSourceTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/log-sources/tag".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.LogSourceTagInputToJSON)(requestParameters.logSourceTagInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Add a tag to one or more log sources
     */
    DefaultApi.prototype.createLogSourceTag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createLogSourceTagRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a new organization contact
     */
    DefaultApi.prototype.createOrgContactRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createOrgContact.');
                        }
                        if (requestParameters.organizationContactInput === null || requestParameters.organizationContactInput === undefined) {
                            throw new runtime.RequiredError('organizationContactInput', 'Required parameter requestParameters.organizationContactInput was null or undefined when calling createOrgContact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/contacts".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OrganizationContactInputToJSON)(requestParameters.organizationContactInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationContactFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new organization contact
     */
    DefaultApi.prototype.createOrgContact = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrgContactRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new site for a customer
     */
    DefaultApi.prototype.createOrganizationSiteV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createOrganizationSiteV2.');
                        }
                        if (requestParameters.organizationSiteV2 === null || requestParameters.organizationSiteV2 === undefined) {
                            throw new runtime.RequiredError('organizationSiteV2', 'Required parameter requestParameters.organizationSiteV2 was null or undefined when calling createOrganizationSiteV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/sites".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OrganizationSiteV2ToJSON)(requestParameters.organizationSiteV2),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationSiteV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new site for a customer
     */
    DefaultApi.prototype.createOrganizationSiteV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrganizationSiteV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.createScannerProfileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createScannerProfile.');
                        }
                        if (requestParameters.scannerProfile === null || requestParameters.scannerProfile === undefined) {
                            throw new runtime.RequiredError('scannerProfile', 'Required parameter requestParameters.scannerProfile was null or undefined when calling createScannerProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/scanners".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ScannerProfileToJSON)(requestParameters.scannerProfile),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScannerProfileFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.createScannerProfile = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createScannerProfileRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.createSensorProfileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createSensorProfile.');
                        }
                        if (requestParameters.sensorProfile === null || requestParameters.sensorProfile === undefined) {
                            throw new runtime.RequiredError('sensorProfile', 'Required parameter requestParameters.sensorProfile was null or undefined when calling createSensorProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensor-profile".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SensorProfileToJSON)(requestParameters.sensorProfile),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SensorProfileFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.createSensorProfile = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSensorProfileRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create a new ticket
     */
    DefaultApi.prototype.createTicketRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTicket.');
                        }
                        if (requestParameters.createTicketInput === null || requestParameters.createTicketInput === undefined) {
                            throw new runtime.RequiredError('createTicketInput', 'Required parameter requestParameters.createTicketInput was null or undefined when calling createTicket.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/tickets".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateTicketInputToJSON)(requestParameters.createTicketInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateTicketOutputFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * create a new ticket
     */
    DefaultApi.prototype.createTicket = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTicketRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * this endpoint adds a comment to a ticket
     */
    DefaultApi.prototype.createTicketCommentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTicketComment.');
                        }
                        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
                            throw new runtime.RequiredError('ticketId', 'Required parameter requestParameters.ticketId was null or undefined when calling createTicketComment.');
                        }
                        if (requestParameters.createTicketCommentInput === null || requestParameters.createTicketCommentInput === undefined) {
                            throw new runtime.RequiredError('createTicketCommentInput', 'Required parameter requestParameters.createTicketCommentInput was null or undefined when calling createTicketComment.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/tickets/{ticketId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("ticketId", "}"), encodeURIComponent(String(requestParameters.ticketId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateTicketCommentInputToJSON)(requestParameters.createTicketCommentInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TicketWithCommentsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * this endpoint adds a comment to a ticket
     */
    DefaultApi.prototype.createTicketComment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTicketCommentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete scan schedules for Agent
     */
    DefaultApi.prototype.deleteAgentSchedulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAgentSchedules.');
                        }
                        if (requestParameters.deleteAgentSchedulesInput === null || requestParameters.deleteAgentSchedulesInput === undefined) {
                            throw new runtime.RequiredError('deleteAgentSchedulesInput', 'Required parameter requestParameters.deleteAgentSchedulesInput was null or undefined when calling deleteAgentSchedules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/agent".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DeleteAgentSchedulesInputToJSON)(requestParameters.deleteAgentSchedulesInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete scan schedules for Agent
     */
    DefaultApi.prototype.deleteAgentSchedules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAgentSchedulesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.deleteCustomerCredentialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteCustomerCredential.');
                        }
                        if (requestParameters.deploymentId === null || requestParameters.deploymentId === undefined) {
                            throw new runtime.RequiredError('deploymentId', 'Required parameter requestParameters.deploymentId was null or undefined when calling deleteCustomerCredential.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/customer-credential/{deploymentId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("deploymentId", "}"), encodeURIComponent(String(requestParameters.deploymentId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DeleteCustomerCredential200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.deleteCustomerCredential = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteCustomerCredentialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete EVA schedules
     */
    DefaultApi.prototype.deleteEvaSchedulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteEvaSchedules.');
                        }
                        if (requestParameters.deleteEvaSchedulesInput === null || requestParameters.deleteEvaSchedulesInput === undefined) {
                            throw new runtime.RequiredError('deleteEvaSchedulesInput', 'Required parameter requestParameters.deleteEvaSchedulesInput was null or undefined when calling deleteEvaSchedules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/eva".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DeleteEvaSchedulesInputToJSON)(requestParameters.deleteEvaSchedulesInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete EVA schedules
     */
    DefaultApi.prototype.deleteEvaSchedules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteEvaSchedulesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete credential scan
     */
    DefaultApi.prototype.deleteIvaCredentialScanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteIvaCredentialScan.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling deleteIvaCredentialScan.');
                        }
                        if (requestParameters.credentialId === null || requestParameters.credentialId === undefined) {
                            throw new runtime.RequiredError('credentialId', 'Required parameter requestParameters.credentialId was null or undefined when calling deleteIvaCredentialScan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-credentials/{credentialId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))).replace("{".concat("credentialId", "}"), encodeURIComponent(String(requestParameters.credentialId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete credential scan
     */
    DefaultApi.prototype.deleteIvaCredentialScan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteIvaCredentialScanRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete scan schedules for iva
     */
    DefaultApi.prototype.deleteIvaSchedulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteIvaSchedules.');
                        }
                        if (requestParameters.deleteIvaSchedulesInput === null || requestParameters.deleteIvaSchedulesInput === undefined) {
                            throw new runtime.RequiredError('deleteIvaSchedulesInput', 'Required parameter requestParameters.deleteIvaSchedulesInput was null or undefined when calling deleteIvaSchedules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/iva".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DeleteIvaSchedulesInputToJSON)(requestParameters.deleteIvaSchedulesInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete scan schedules for iva
     */
    DefaultApi.prototype.deleteIvaSchedules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteIvaSchedulesRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a log search request
     */
    DefaultApi.prototype.deleteLogSearchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteLogSearch.');
                        }
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling deleteLogSearch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/{requestId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters.requestId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a log search request
     */
    DefaultApi.prototype.deleteLogSearch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteLogSearchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove a tag from one or more log sources
     */
    DefaultApi.prototype.deleteLogSourceTagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteLogSourceTag.');
                        }
                        if (requestParameters.logSourceTagInput === null || requestParameters.logSourceTagInput === undefined) {
                            throw new runtime.RequiredError('logSourceTagInput', 'Required parameter requestParameters.logSourceTagInput was null or undefined when calling deleteLogSourceTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/log-sources/tag".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.LogSourceTagInputToJSON)(requestParameters.logSourceTagInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove a tag from one or more log sources
     */
    DefaultApi.prototype.deleteLogSourceTag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteLogSourceTagRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Request to delete an organization contact
     */
    DefaultApi.prototype.deleteOrgContactRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteOrgContact.');
                        }
                        if (requestParameters.contactId === null || requestParameters.contactId === undefined) {
                            throw new runtime.RequiredError('contactId', 'Required parameter requestParameters.contactId was null or undefined when calling deleteOrgContact.');
                        }
                        if (requestParameters.organizationContactDeletionRequest === null || requestParameters.organizationContactDeletionRequest === undefined) {
                            throw new runtime.RequiredError('organizationContactDeletionRequest', 'Required parameter requestParameters.organizationContactDeletionRequest was null or undefined when calling deleteOrgContact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/contacts/{contactId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("contactId", "}"), encodeURIComponent(String(requestParameters.contactId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OrganizationContactDeletionRequestToJSON)(requestParameters.organizationContactDeletionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationContactFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Request to delete an organization contact
     */
    DefaultApi.prototype.deleteOrgContact = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrgContactRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a specific site
     */
    DefaultApi.prototype.deleteOrganizationSiteV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteOrganizationSiteV2.');
                        }
                        if (requestParameters.siteUUID === null || requestParameters.siteUUID === undefined) {
                            throw new runtime.RequiredError('siteUUID', 'Required parameter requestParameters.siteUUID was null or undefined when calling deleteOrganizationSiteV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/sites/{siteUUID}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("siteUUID", "}"), encodeURIComponent(String(requestParameters.siteUUID))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a specific site
     */
    DefaultApi.prototype.deleteOrganizationSiteV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationSiteV2Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.deleteScannerProfileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteScannerProfile.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling deleteScannerProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/scanners/{scannerId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.deleteScannerProfile = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteScannerProfileRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a sensor identified by its serial number within a specific deployment.
     * Delete a sensor
     */
    DefaultApi.prototype.deleteSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteSensor.');
                        }
                        if (requestParameters.deploymentId === null || requestParameters.deploymentId === undefined) {
                            throw new runtime.RequiredError('deploymentId', 'Required parameter requestParameters.deploymentId was null or undefined when calling deleteSensor.');
                        }
                        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
                            throw new runtime.RequiredError('serialNumber', 'Required parameter requestParameters.serialNumber was null or undefined when calling deleteSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/deployments/{deploymentId}/sensor/{serialNumber}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("deploymentId", "}"), encodeURIComponent(String(requestParameters.deploymentId))).replace("{".concat("serialNumber", "}"), encodeURIComponent(String(requestParameters.serialNumber))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a sensor identified by its serial number within a specific deployment.
     * Delete a sensor
     */
    DefaultApi.prototype.deleteSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a sensor and remove its profile
     */
    DefaultApi.prototype.deleteSensorProfileByUUIDRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteSensorProfileByUUID.');
                        }
                        if (requestParameters.profileUUID === null || requestParameters.profileUUID === undefined) {
                            throw new runtime.RequiredError('profileUUID', 'Required parameter requestParameters.profileUUID was null or undefined when calling deleteSensorProfileByUUID.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensor-profiles/{profileUUID}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("profileUUID", "}"), encodeURIComponent(String(requestParameters.profileUUID))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a sensor and remove its profile
     */
    DefaultApi.prototype.deleteSensorProfileByUUID = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteSensorProfileByUUIDRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Download the AD sensor image
     */
    DefaultApi.prototype.downloadAdSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling downloadAdSensor.');
                        }
                        if (requestParameters.adSensorRequest === null || requestParameters.adSensorRequest === undefined) {
                            throw new runtime.RequiredError('adSensorRequest', 'Required parameter requestParameters.adSensorRequest was null or undefined when calling downloadAdSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/adsensor/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.AdSensorRequestToJSON)(requestParameters.adSensorRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AdSensorResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Download the AD sensor image
     */
    DefaultApi.prototype.downloadAdSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadAdSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads the requested agent platform
     */
    DefaultApi.prototype.downloadAgentPlatformRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling downloadAgentPlatform.');
                        }
                        if (requestParameters.platformOs === null || requestParameters.platformOs === undefined) {
                            throw new runtime.RequiredError('platformOs', 'Required parameter requestParameters.platformOs was null or undefined when calling downloadAgentPlatform.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/platforms/{platformOs}/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("platformOs", "}"), encodeURIComponent(String(requestParameters.platformOs))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads the requested agent platform
     */
    DefaultApi.prototype.downloadAgentPlatform = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadAgentPlatformRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Download the hyper-v image
     */
    DefaultApi.prototype.downloadHyperVSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling downloadHyperVSensor.');
                        }
                        if (requestParameters.sensorImageId === null || requestParameters.sensorImageId === undefined) {
                            throw new runtime.RequiredError('sensorImageId', 'Required parameter requestParameters.sensorImageId was null or undefined when calling downloadHyperVSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/hyperv/{sensorImageId}/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("sensorImageId", "}"), encodeURIComponent(String(requestParameters.sensorImageId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.VirtualSensorURLFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Download the hyper-v image
     */
    DefaultApi.prototype.downloadHyperVSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadHyperVSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Download the virtual sensor image
     */
    DefaultApi.prototype.downloadVirtualSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling downloadVirtualSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/virtualsensor/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.VirtualSensorURLFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Download the virtual sensor image
     */
    DefaultApi.prototype.downloadVirtualSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadVirtualSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Edit a scan schedule for Agent
     */
    DefaultApi.prototype.editAgentScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling editAgentSchedule.');
                        }
                        if (requestParameters.scoutGroupId === null || requestParameters.scoutGroupId === undefined) {
                            throw new runtime.RequiredError('scoutGroupId', 'Required parameter requestParameters.scoutGroupId was null or undefined when calling editAgentSchedule.');
                        }
                        if (requestParameters.agentScheduleInput === null || requestParameters.agentScheduleInput === undefined) {
                            throw new runtime.RequiredError('agentScheduleInput', 'Required parameter requestParameters.agentScheduleInput was null or undefined when calling editAgentSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/agent/{scoutGroupId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scoutGroupId", "}"), encodeURIComponent(String(requestParameters.scoutGroupId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.AgentScheduleInputToJSON)(requestParameters.agentScheduleInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Edit a scan schedule for Agent
     */
    DefaultApi.prototype.editAgentSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editAgentScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Edit EVA schedule
     */
    DefaultApi.prototype.editEvaScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling editEvaSchedule.');
                        }
                        if (requestParameters.evaScheduleEdit === null || requestParameters.evaScheduleEdit === undefined) {
                            throw new runtime.RequiredError('evaScheduleEdit', 'Required parameter requestParameters.evaScheduleEdit was null or undefined when calling editEvaSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/eva/{groupId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.EvaScheduleEditToJSON)(requestParameters.evaScheduleEdit),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Edit EVA schedule
     */
    DefaultApi.prototype.editEvaSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editEvaScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Edit a scan schedule for Iva
     */
    DefaultApi.prototype.editIvaScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling editIvaSchedule.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling editIvaSchedule.');
                        }
                        if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                            throw new runtime.RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling editIvaSchedule.');
                        }
                        if (requestParameters.ivaScheduleInput === null || requestParameters.ivaScheduleInput === undefined) {
                            throw new runtime.RequiredError('ivaScheduleInput', 'Required parameter requestParameters.ivaScheduleInput was null or undefined when calling editIvaSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-schedules/{scheduleId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))).replace("{".concat("scheduleId", "}"), encodeURIComponent(String(requestParameters.scheduleId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.IvaScheduleInputToJSON)(requestParameters.ivaScheduleInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Edit a scan schedule for Iva
     */
    DefaultApi.prototype.editIvaSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editIvaScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Edit a scanner\'s config
     */
    DefaultApi.prototype.editScannerConfigRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling editScannerConfig.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling editScannerConfig.');
                        }
                        if (requestParameters.editScannerConfigInput === null || requestParameters.editScannerConfigInput === undefined) {
                            throw new runtime.RequiredError('editScannerConfigInput', 'Required parameter requestParameters.editScannerConfigInput was null or undefined when calling editScannerConfig.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scanners/{scannerId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.EditScannerConfigInputToJSON)(requestParameters.editScannerConfigInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Edit a scanner\'s config
     */
    DefaultApi.prototype.editScannerConfig = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editScannerConfigRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Edit a scanner\'s config
     */
    DefaultApi.prototype.editScannerConfigV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling editScannerConfigV2.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling editScannerConfigV2.');
                        }
                        if (requestParameters.editScannerConfigInputV2 === null || requestParameters.editScannerConfigInputV2 === undefined) {
                            throw new runtime.RequiredError('editScannerConfigInputV2', 'Required parameter requestParameters.editScannerConfigInputV2 was null or undefined when calling editScannerConfigV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/scanners/{scannerId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.EditScannerConfigInputV2ToJSON)(requestParameters.editScannerConfigInputV2),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.EditScannerConfigErrorFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Edit a scanner\'s config
     */
    DefaultApi.prototype.editScannerConfigV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editScannerConfigV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * executes a data explorer histogram query
     */
    DefaultApi.prototype.executeDataExplorerHistogramQueryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling executeDataExplorerHistogramQuery.');
                        }
                        if (requestParameters.start === null || requestParameters.start === undefined) {
                            throw new runtime.RequiredError('start', 'Required parameter requestParameters.start was null or undefined when calling executeDataExplorerHistogramQuery.');
                        }
                        if (requestParameters.end === null || requestParameters.end === undefined) {
                            throw new runtime.RequiredError('end', 'Required parameter requestParameters.end was null or undefined when calling executeDataExplorerHistogramQuery.');
                        }
                        if (requestParameters.dataExplorerHistogramQuery === null || requestParameters.dataExplorerHistogramQuery === undefined) {
                            throw new runtime.RequiredError('dataExplorerHistogramQuery', 'Required parameter requestParameters.dataExplorerHistogramQuery was null or undefined when calling executeDataExplorerHistogramQuery.');
                        }
                        queryParameters = {};
                        if (requestParameters.start !== undefined) {
                            queryParameters['start'] = requestParameters.start;
                        }
                        if (requestParameters.end !== undefined) {
                            queryParameters['end'] = requestParameters.end;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/data-explorer/execute/histogram".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DataExplorerHistogramQueryToJSON)(requestParameters.dataExplorerHistogramQuery),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DataExplorerResultsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * executes a data explorer histogram query
     */
    DefaultApi.prototype.executeDataExplorerHistogramQuery = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.executeDataExplorerHistogramQueryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * executes a data explorer query
     */
    DefaultApi.prototype.executeDataExplorerQueryV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling executeDataExplorerQueryV2.');
                        }
                        if (requestParameters.start === null || requestParameters.start === undefined) {
                            throw new runtime.RequiredError('start', 'Required parameter requestParameters.start was null or undefined when calling executeDataExplorerQueryV2.');
                        }
                        if (requestParameters.end === null || requestParameters.end === undefined) {
                            throw new runtime.RequiredError('end', 'Required parameter requestParameters.end was null or undefined when calling executeDataExplorerQueryV2.');
                        }
                        if (requestParameters.dataExplorerQuery === null || requestParameters.dataExplorerQuery === undefined) {
                            throw new runtime.RequiredError('dataExplorerQuery', 'Required parameter requestParameters.dataExplorerQuery was null or undefined when calling executeDataExplorerQueryV2.');
                        }
                        queryParameters = {};
                        if (requestParameters.start !== undefined) {
                            queryParameters['start'] = requestParameters.start;
                        }
                        if (requestParameters.end !== undefined) {
                            queryParameters['end'] = requestParameters.end;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/data-explorer/execute".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DataExplorerQueryToJSON)(requestParameters.dataExplorerQuery),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DataExplorerTableResultsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * executes a data explorer query
     */
    DefaultApi.prototype.executeDataExplorerQueryV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.executeDataExplorerQueryV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAddressSuggestionDetailFromPlaceIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.placeId === null || requestParameters.placeId === undefined) {
                            throw new runtime.RequiredError('placeId', 'Required parameter requestParameters.placeId was null or undefined when calling getAddressSuggestionDetailFromPlaceId.');
                        }
                        queryParameters = {};
                        if (requestParameters.placeId !== undefined) {
                            queryParameters['placeId'] = requestParameters.placeId;
                        }
                        if (requestParameters.language !== undefined) {
                            queryParameters['language'] = requestParameters.language;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/addresses/detail",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AddressSuggestionDetailFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAddressSuggestionDetailFromPlaceId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAddressSuggestionDetailFromPlaceIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAddressSuggestionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.addressText === null || requestParameters.addressText === undefined) {
                            throw new runtime.RequiredError('addressText', 'Required parameter requestParameters.addressText was null or undefined when calling getAddressSuggestions.');
                        }
                        if (requestParameters.limit === null || requestParameters.limit === undefined) {
                            throw new runtime.RequiredError('limit', 'Required parameter requestParameters.limit was null or undefined when calling getAddressSuggestions.');
                        }
                        queryParameters = {};
                        if (requestParameters.addressText !== undefined) {
                            queryParameters['addressText'] = requestParameters.addressText;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.language !== undefined) {
                            queryParameters['language'] = requestParameters.language;
                        }
                        if (requestParameters.categories !== undefined) {
                            queryParameters['categories'] = requestParameters.categories;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/addresses/suggestions",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AddressSuggestionFromJSON); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAddressSuggestions = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAddressSuggestionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get deployed agent
     */
    DefaultApi.prototype.getAgentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgent.');
                        }
                        if (requestParameters.agentId === null || requestParameters.agentId === undefined) {
                            throw new runtime.RequiredError('agentId', 'Required parameter requestParameters.agentId was null or undefined when calling getAgent.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agents/{agentId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("agentId", "}"), encodeURIComponent(String(requestParameters.agentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get deployed agent
     */
    DefaultApi.prototype.getAgent = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the auto deactivation threshold for a customer
     * Returns the auto deactivation threshold for a customer
     */
    DefaultApi.prototype.getAgentCustomerConfigurationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentCustomerConfiguration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/configuration".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentCustomerConfigurationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the auto deactivation threshold for a customer
     * Returns the auto deactivation threshold for a customer
     */
    DefaultApi.prototype.getAgentCustomerConfiguration = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentCustomerConfigurationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the org wide agent configurations for the customer
     * Returns the org wide agent configurations for the customer
     */
    DefaultApi.prototype.getAgentCustomerConfigurationV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentCustomerConfigurationV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/agent/configuration".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentCustomerConfigurationV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the org wide agent configurations for the customer
     * Returns the org wide agent configurations for the customer
     */
    DefaultApi.prototype.getAgentCustomerConfigurationV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentCustomerConfigurationV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get available agent modules
     */
    DefaultApi.prototype.getAgentModulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentModules.');
                        }
                        queryParameters = {};
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/modules".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentModulesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get available agent modules
     */
    DefaultApi.prototype.getAgentModules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentModulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get deployed agents V2
     */
    DefaultApi.prototype.getAgentPageV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentPageV2.');
                        }
                        queryParameters = {};
                        if (requestParameters.clientUuidContains !== undefined) {
                            queryParameters['clientUuidContains'] = requestParameters.clientUuidContains;
                        }
                        if (requestParameters.hostname !== undefined) {
                            queryParameters['hostname'] = requestParameters.hostname;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.osType !== undefined) {
                            queryParameters['osType'] = requestParameters.osType;
                        }
                        if (requestParameters.osName !== undefined) {
                            queryParameters['osName'] = requestParameters.osName;
                        }
                        if (requestParameters.platformOS !== undefined) {
                            queryParameters['platformOS'] = requestParameters.platformOS;
                        }
                        if (requestParameters.ipAddress !== undefined) {
                            queryParameters['ipAddress'] = requestParameters.ipAddress;
                        }
                        if (requestParameters.offlineSince !== undefined) {
                            queryParameters['offlineSince'] = requestParameters.offlineSince;
                        }
                        if (requestParameters.offlineUntil !== undefined) {
                            queryParameters['offlineUntil'] = requestParameters.offlineUntil;
                        }
                        if (requestParameters.firstSeenBefore !== undefined) {
                            queryParameters['firstSeenBefore'] = requestParameters.firstSeenBefore;
                        }
                        if (requestParameters.firstSeenAfter !== undefined) {
                            queryParameters['firstSeenAfter'] = requestParameters.firstSeenAfter;
                        }
                        if (requestParameters.includeModules !== undefined) {
                            queryParameters['includeModules'] = requestParameters.includeModules;
                        }
                        if (requestParameters.includeDomain !== undefined) {
                            queryParameters['includeDomain'] = requestParameters.includeDomain;
                        }
                        if (requestParameters.module !== undefined) {
                            queryParameters['module'] = requestParameters.module;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.containmentDriver !== undefined) {
                            queryParameters['containmentDriver'] = requestParameters.containmentDriver;
                        }
                        if (requestParameters.columns !== undefined) {
                            queryParameters['columns'] = requestParameters.columns;
                        }
                        if (requestParameters.sysmonInstalledVersion !== undefined) {
                            queryParameters['sysmonInstalledVersion'] = requestParameters.sysmonInstalledVersion;
                        }
                        if (requestParameters.domain !== undefined) {
                            queryParameters['domain'] = requestParameters.domain;
                        }
                        if (requestParameters.vendorArch !== undefined) {
                            queryParameters['vendorArch'] = requestParameters.vendorArch;
                        }
                        if (requestParameters.city !== undefined) {
                            queryParameters['city'] = requestParameters.city;
                        }
                        if (requestParameters.country !== undefined) {
                            queryParameters['country'] = requestParameters.country;
                        }
                        if (requestParameters.userName !== undefined) {
                            queryParameters['userName'] = requestParameters.userName;
                        }
                        if (requestParameters.softwareVersionContains !== undefined) {
                            queryParameters['softwareVersionContains'] = requestParameters.softwareVersionContains;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/agents".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentPageV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get deployed agents V2
     */
    DefaultApi.prototype.getAgentPageV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentPageV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns available agent platforms
     */
    DefaultApi.prototype.getAgentPlatformsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentPlatforms.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/platforms".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AgentPlatformFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns available agent platforms
     */
    DefaultApi.prototype.getAgentPlatforms = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentPlatformsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get a scan schedule for Agent
     */
    DefaultApi.prototype.getAgentScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentSchedule.');
                        }
                        if (requestParameters.scoutGroupId === null || requestParameters.scoutGroupId === undefined) {
                            throw new runtime.RequiredError('scoutGroupId', 'Required parameter requestParameters.scoutGroupId was null or undefined when calling getAgentSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/agent/{scoutGroupId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scoutGroupId", "}"), encodeURIComponent(String(requestParameters.scoutGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScheduleRowFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get a scan schedule for Agent
     */
    DefaultApi.prototype.getAgentSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAgentSummaryV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAgentSummaryV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/agent-summary".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentSummaryV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAgentSummaryV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAgentSummaryV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve the alert configuration rule lookups
     */
    DefaultApi.prototype.getAlertConfigurationLookupsRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/configuration-rules/lookups",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AlertConfigurationLookupsWithNameFromJSON); })];
                }
            });
        });
    };
    /**
     * Retrieve the alert configuration rule lookups
     */
    DefaultApi.prototype.getAlertConfigurationLookups = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAlertConfigurationLookupsRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve the schema for the alert configuration rule
     */
    DefaultApi.prototype.getAlertConfigurationRuleSchemaRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAlertConfigurationRuleSchema.');
                        }
                        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
                            throw new runtime.RequiredError('alertId', 'Required parameter requestParameters.alertId was null or undefined when calling getAlertConfigurationRuleSchema.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/configuration-rules/alert/{alertId}/schema".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("alertId", "}"), encodeURIComponent(String(requestParameters.alertId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Retrieve the schema for the alert configuration rule
     */
    DefaultApi.prototype.getAlertConfigurationRuleSchema = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAlertConfigurationRuleSchemaRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve the dictionary of customer alert configuration rules
     */
    DefaultApi.prototype.getAlertConfigurationRulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAlertConfigurationRules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/configuration-rules/alert".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return runtime.mapValues(jsonValue, models_1.AlertConfigurationRuleFromJSON); })];
                }
            });
        });
    };
    /**
     * Retrieve the dictionary of customer alert configuration rules
     */
    DefaultApi.prototype.getAlertConfigurationRules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAlertConfigurationRulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allowlist Endpoints API; displays pod-specific (but not organization-specific) AW infrastructure info
     */
    DefaultApi.prototype.getAllowListRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/resource-center/allow-list",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AllowListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Allowlist Endpoints API; displays pod-specific (but not organization-specific) AW infrastructure info
     */
    DefaultApi.prototype.getAllowList = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllowListRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * the organization\'s assurance subscription details
     */
    DefaultApi.prototype.getAssuranceSubscriptionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAssuranceSubscription.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/assurance-subscription".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AssuranceSubscriptionFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * the organization\'s assurance subscription details
     */
    DefaultApi.prototype.getAssuranceSubscription = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAssuranceSubscriptionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAvailableSeriesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/available-series",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AvailableSeriesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getAvailableSeries = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAvailableSeriesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * A temporary endpoint to get organization-aware capabilities for the given user. This endpoint will be removed once the capabilities are handle by the Permissions Service. Return all capabilities when the user is present in the Console (AWN Employee).
     */
    DefaultApi.prototype.getCapabilitiesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCapabilities.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/capabilities".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CapabilitiesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * A temporary endpoint to get organization-aware capabilities for the given user. This endpoint will be removed once the capabilities are handle by the Permissions Service. Return all capabilities when the user is present in the Console (AWN Employee).
     */
    DefaultApi.prototype.getCapabilities = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCapabilitiesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCapabilitiesBySeriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.seriesId === null || requestParameters.seriesId === undefined) {
                            throw new runtime.RequiredError('seriesId', 'Required parameter requestParameters.seriesId was null or undefined when calling getCapabilitiesBySeries.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/capability-schema/{seriesId}".replace("{".concat("seriesId", "}"), encodeURIComponent(String(requestParameters.seriesId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SeriesCapabilitiesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCapabilitiesBySeries = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCapabilitiesBySeriesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCloudSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCloudSensor.');
                        }
                        if (requestParameters.cloudSensorId === null || requestParameters.cloudSensorId === undefined) {
                            throw new runtime.RequiredError('cloudSensorId', 'Required parameter requestParameters.cloudSensorId was null or undefined when calling getCloudSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/cloud-sensors/{cloudSensorId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("cloudSensorId", "}"), encodeURIComponent(String(requestParameters.cloudSensorId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CloudSensorFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCloudSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCloudSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCloudSensorPageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCloudSensorPage.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.vendor !== undefined) {
                            queryParameters['vendor'] = requestParameters.vendor;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/cloud-sensors".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CloudSensorPageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCloudSensorPage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCloudSensorPageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCloudSensorSummaryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCloudSensorSummary.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/cloud-sensor-summary".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CloudSensorSummaryFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCloudSensorSummary = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCloudSensorSummaryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve the list of customer configuration rules
     */
    DefaultApi.prototype.getConfigurationRulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getConfigurationRules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/configuration-rules".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ConfigurationRulesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve the list of customer configuration rules
     */
    DefaultApi.prototype.getConfigurationRules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConfigurationRulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the email and phone number for contacting Arctic Wolf; Exposes publicly available information and is therefore not authorized
     */
    DefaultApi.prototype.getContactInfoRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/contact-information",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ContactInfoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the email and phone number for contacting Arctic Wolf; Exposes publicly available information and is therefore not authorized
     */
    DefaultApi.prototype.getContactInfo = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContactInfoRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getContactUsagesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getContactUsages.');
                        }
                        if (requestParameters.contactId === null || requestParameters.contactId === undefined) {
                            throw new runtime.RequiredError('contactId', 'Required parameter requestParameters.contactId was null or undefined when calling getContactUsages.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/contacts/{contactId}/usages".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("contactId", "}"), encodeURIComponent(String(requestParameters.contactId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ContactUsagesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getContactUsages = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContactUsagesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * the organization\'s coverage score
     */
    DefaultApi.prototype.getCoverageScoreRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCoverageScore.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/coverage-score".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CoverageScoreFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * the organization\'s coverage score
     */
    DefaultApi.prototype.getCoverageScore = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCoverageScoreRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch a page of coverage scores; each customer has zero or one coverage score record; a customer would not have a coverage score if they are brand new and the daily task which computes the scores hasn\'t run yet; coverage score is not refreshed for inactive customers
     */
    DefaultApi.prototype.getCoverageScoresPageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCoverageScoresPage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/coverage-score-details".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CoverageScoreDetailsFromJSON); })];
                }
            });
        });
    };
    /**
     * Fetch a page of coverage scores; each customer has zero or one coverage score record; a customer would not have a coverage score if they are brand new and the daily task which computes the scores hasn\'t run yet; coverage score is not refreshed for inactive customers
     */
    DefaultApi.prototype.getCoverageScoresPage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCoverageScoresPageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * returns the contents of the CSV file attached to a ticket
     */
    DefaultApi.prototype.getCsvTicketAttachmentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCsvTicketAttachment.');
                        }
                        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
                            throw new runtime.RequiredError('ticketId', 'Required parameter requestParameters.ticketId was null or undefined when calling getCsvTicketAttachment.');
                        }
                        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
                            throw new runtime.RequiredError('attachmentId', 'Required parameter requestParameters.attachmentId was null or undefined when calling getCsvTicketAttachment.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/tickets/{ticketId}/attachments/{attachmentId}/csv".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("ticketId", "}"), encodeURIComponent(String(requestParameters.ticketId))).replace("{".concat("attachmentId", "}"), encodeURIComponent(String(requestParameters.attachmentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CsvContentsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * returns the contents of the CSV file attached to a ticket
     */
    DefaultApi.prototype.getCsvTicketAttachment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCsvTicketAttachmentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerAddressesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCustomerAddresses.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/addresses".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.AddressFromJSON); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerAddresses = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerAddressesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all the contacts for the customer and msp
     */
    DefaultApi.prototype.getCustomerContactsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCustomerContacts.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/customer-contacts".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationContactsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns all the contacts for the customer and msp
     */
    DefaultApi.prototype.getCustomerContacts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContactsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the containment allowlist for the specified customer
     */
    DefaultApi.prototype.getCustomerContainmentAllowListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCustomerContainmentAllowList.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/containment/allowlist".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentContainmentAllowListV1FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the containment allowlist for the specified customer
     */
    DefaultApi.prototype.getCustomerContainmentAllowList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerContainmentAllowListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerCredentialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCustomerCredential.');
                        }
                        if (requestParameters.deploymentId === null || requestParameters.deploymentId === undefined) {
                            throw new runtime.RequiredError('deploymentId', 'Required parameter requestParameters.deploymentId was null or undefined when calling getCustomerCredential.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/customer-credential/{deploymentId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("deploymentId", "}"), encodeURIComponent(String(requestParameters.deploymentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CredentialFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerCredential = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerCredentialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerEmailDomainsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCustomerEmailDomains.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/email-domains".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerEmailDomains = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerEmailDomainsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerSitesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getCustomerSites.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sites".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SiteFromJSON); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getCustomerSites = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerSitesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve a list of profiles for possible customerizations
     */
    DefaultApi.prototype.getCustomerizationProfilesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/configuration-rules/profiles/customerizations",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RuleProfileFromJSON); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of profiles for possible customerizations
     */
    DefaultApi.prototype.getCustomerizationProfiles = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerizationProfilesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the values for a specific field
     */
    DefaultApi.prototype.getDataExplorerSuggestionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getDataExplorerSuggestions.');
                        }
                        if (requestParameters.field === null || requestParameters.field === undefined) {
                            throw new runtime.RequiredError('field', 'Required parameter requestParameters.field was null or undefined when calling getDataExplorerSuggestions.');
                        }
                        if (requestParameters.input === null || requestParameters.input === undefined) {
                            throw new runtime.RequiredError('input', 'Required parameter requestParameters.input was null or undefined when calling getDataExplorerSuggestions.');
                        }
                        if (requestParameters.start === null || requestParameters.start === undefined) {
                            throw new runtime.RequiredError('start', 'Required parameter requestParameters.start was null or undefined when calling getDataExplorerSuggestions.');
                        }
                        if (requestParameters.end === null || requestParameters.end === undefined) {
                            throw new runtime.RequiredError('end', 'Required parameter requestParameters.end was null or undefined when calling getDataExplorerSuggestions.');
                        }
                        queryParameters = {};
                        if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                        }
                        if (requestParameters.input !== undefined) {
                            queryParameters['input'] = requestParameters.input;
                        }
                        if (requestParameters.source !== undefined) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.start !== undefined) {
                            queryParameters['start'] = requestParameters.start;
                        }
                        if (requestParameters.end !== undefined) {
                            queryParameters['end'] = requestParameters.end;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/data-explorer/suggest".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get the values for a specific field
     */
    DefaultApi.prototype.getDataExplorerSuggestions = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataExplorerSuggestionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets detection details by detection id
     */
    DefaultApi.prototype.getDetectionDetailRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.detectionId === null || requestParameters.detectionId === undefined) {
                            throw new runtime.RequiredError('detectionId', 'Required parameter requestParameters.detectionId was null or undefined when calling getDetectionDetail.');
                        }
                        queryParameters = {};
                        if (requestParameters.detectionId !== undefined) {
                            queryParameters['detectionId'] = requestParameters.detectionId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/detections/detail",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DetectionFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets detection details by detection id
     */
    DefaultApi.prototype.getDetectionDetail = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDetectionDetailRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets and filters detections by various parameters
     */
    DefaultApi.prototype.getDetectionPageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.searchString !== undefined) {
                            queryParameters['searchString'] = requestParameters.searchString;
                        }
                        if (requestParameters.useCase !== undefined) {
                            queryParameters['useCase'] = requestParameters.useCase;
                        }
                        if (requestParameters.technology) {
                            queryParameters['technology'] = requestParameters.technology;
                        }
                        if (requestParameters.platform) {
                            queryParameters['platform'] = requestParameters.platform;
                        }
                        if (requestParameters.severity) {
                            queryParameters['severity'] = requestParameters.severity;
                        }
                        if (requestParameters.cvesDetections !== undefined) {
                            queryParameters['cvesDetections'] = requestParameters.cvesDetections;
                        }
                        if (requestParameters.applications) {
                            queryParameters['applications'] = requestParameters.applications;
                        }
                        if (requestParameters.firstPublishedStart !== undefined) {
                            queryParameters['firstPublishedStart'] = requestParameters.firstPublishedStart.toISOString();
                        }
                        if (requestParameters.firstPublishedEnd !== undefined) {
                            queryParameters['firstPublishedEnd'] = requestParameters.firstPublishedEnd.toISOString();
                        }
                        if (requestParameters.lastModifiedStart !== undefined) {
                            queryParameters['lastModifiedStart'] = requestParameters.lastModifiedStart.toISOString();
                        }
                        if (requestParameters.lastModifiedEnd !== undefined) {
                            queryParameters['lastModifiedEnd'] = requestParameters.lastModifiedEnd.toISOString();
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['perPage'] = requestParameters.perPage;
                        }
                        if (requestParameters.sortBy !== undefined) {
                            queryParameters['sortBy'] = requestParameters.sortBy;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/detections",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DetectionPageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets and filters detections by various parameters
     */
    DefaultApi.prototype.getDetectionPage = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDetectionPageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets available options for the \'DetectionsApplications\' parameter on the \'detections\' endpoint
     */
    DefaultApi.prototype.getDetectionsApplicationFiltersRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/detections/application-filters",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Gets available options for the \'DetectionsApplications\' parameter on the \'detections\' endpoint
     */
    DefaultApi.prototype.getDetectionsApplicationFilters = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDetectionsApplicationFiltersRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get the date time for the earliest existing log search artifact for a customer
     */
    DefaultApi.prototype.getEarliestLogSearchArtifactRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getEarliestLogSearchArtifact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/earliest".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogSearchEarliestArtifactFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the date time for the earliest existing log search artifact for a customer
     */
    DefaultApi.prototype.getEarliestLogSearchArtifact = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEarliestLogSearchArtifactRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the escalation configuration details for the Organization
     */
    DefaultApi.prototype.getEscalationConfigsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getEscalationConfigs.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/escalation-configs".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.EscalationConfigsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the escalation configuration details for the Organization
     */
    DefaultApi.prototype.getEscalationConfigs = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEscalationConfigsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the escalation configuration details for the Organization
     */
    DefaultApi.prototype.getEscalationConfigsV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getEscalationConfigsV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/escalation-configs".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.EscalationConfigsV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the escalation configuration details for the Organization
     */
    DefaultApi.prototype.getEscalationConfigsV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEscalationConfigsV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getFederatedAuthenticationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getFederatedAuthentication.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/federated-authentication".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.FederatedAuthenticationsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getFederatedAuthentication = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFederatedAuthenticationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This API gets the flow data view matching the query parameters.
     */
    DefaultApi.prototype.getFlowDataRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getFlowData.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getFlowData.');
                        }
                        if (requestParameters.start === null || requestParameters.start === undefined) {
                            throw new runtime.RequiredError('start', 'Required parameter requestParameters.start was null or undefined when calling getFlowData.');
                        }
                        if (requestParameters.end === null || requestParameters.end === undefined) {
                            throw new runtime.RequiredError('end', 'Required parameter requestParameters.end was null or undefined when calling getFlowData.');
                        }
                        queryParameters = {};
                        if (requestParameters.start !== undefined) {
                            queryParameters['start'] = requestParameters.start;
                        }
                        if (requestParameters.end !== undefined) {
                            queryParameters['end'] = requestParameters.end;
                        }
                        if (requestParameters.device !== undefined) {
                            queryParameters['device'] = requestParameters.device;
                        }
                        if (requestParameters.protocol !== undefined) {
                            queryParameters['protocol'] = requestParameters.protocol;
                        }
                        if (requestParameters.site !== undefined) {
                            queryParameters['site'] = requestParameters.site;
                        }
                        if (requestParameters.sensor !== undefined) {
                            queryParameters['sensor'] = requestParameters.sensor;
                        }
                        if (requestParameters.location !== undefined) {
                            queryParameters['location'] = requestParameters.location;
                        }
                        if (requestParameters.direction !== undefined) {
                            queryParameters['direction'] = requestParameters.direction;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/flow-data/{type}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("type", "}"), encodeURIComponent(String(requestParameters.type))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DataFlowResultsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This API gets the flow data view matching the query parameters.
     */
    DefaultApi.prototype.getFlowData = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFlowDataRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * API Health Summary
     */
    DefaultApi.prototype.getHealthInfoRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/health",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.HealthFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * API Health Summary
     */
    DefaultApi.prototype.getHealthInfo = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHealthInfoRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * return the dashboard incidents, both ticketed and non
     */
    DefaultApi.prototype.getIncidentsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getIncidents.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/incidents".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.IncidentsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * return the dashboard incidents, both ticketed and non
     */
    DefaultApi.prototype.getIncidents = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIncidentsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the list of cloud sensor types installed for the customer.
     */
    DefaultApi.prototype.getInstalledCloudSensorTypesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getInstalledCloudSensorTypes.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/installed-cloud-sensor-types".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get the list of cloud sensor types installed for the customer.
     */
    DefaultApi.prototype.getInstalledCloudSensorTypes = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInstalledCloudSensorTypesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve a list of profiles for possible intentions
     */
    DefaultApi.prototype.getIntentionProfilesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/configuration-rules/profiles/intentions",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ConfigProfileFromJSON); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of profiles for possible intentions
     */
    DefaultApi.prototype.getIntentionProfiles = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIntentionProfilesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getIvaScanScheduleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getIvaScanSchedule.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getIvaScanSchedule.');
                        }
                        if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                            throw new runtime.RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling getIvaScanSchedule.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-schedules/{scheduleId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))).replace("{".concat("scheduleId", "}"), encodeURIComponent(String(requestParameters.scheduleId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScheduleRowFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getIvaScanSchedule = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIvaScanScheduleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the license utilization/quotas
     */
    DefaultApi.prototype.getLicenseUsageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLicenseUsage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/license-usage".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LicenseUsageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the license utilization/quotas
     */
    DefaultApi.prototype.getLicenseUsage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLicenseUsageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get the download link for an existing log query export
     */
    DefaultApi.prototype.getLogQueryExportDownloadRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogQueryExportDownload.');
                        }
                        if (requestParameters.queryId === null || requestParameters.queryId === undefined) {
                            throw new runtime.RequiredError('queryId', 'Required parameter requestParameters.queryId was null or undefined when calling getLogQueryExportDownload.');
                        }
                        if (requestParameters.outputId === null || requestParameters.outputId === undefined) {
                            throw new runtime.RequiredError('outputId', 'Required parameter requestParameters.outputId was null or undefined when calling getLogQueryExportDownload.');
                        }
                        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
                            throw new runtime.RequiredError('fileId', 'Required parameter requestParameters.fileId was null or undefined when calling getLogQueryExportDownload.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/log-query/{queryId}/output/{outputId}/file/{fileId}/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("queryId", "}"), encodeURIComponent(String(requestParameters.queryId))).replace("{".concat("outputId", "}"), encodeURIComponent(String(requestParameters.outputId))).replace("{".concat("fileId", "}"), encodeURIComponent(String(requestParameters.fileId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogQueryExportDownloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the download link for an existing log query export
     */
    DefaultApi.prototype.getLogQueryExportDownload = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogQueryExportDownloadRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * retrieve a single export
     */
    DefaultApi.prototype.getLogSearchExportRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSearchExport.');
                        }
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling getLogSearchExport.');
                        }
                        if (requestParameters.exportId === null || requestParameters.exportId === undefined) {
                            throw new runtime.RequiredError('exportId', 'Required parameter requestParameters.exportId was null or undefined when calling getLogSearchExport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/{requestId}/exports/{exportId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters.requestId))).replace("{".concat("exportId", "}"), encodeURIComponent(String(requestParameters.exportId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogSearchExportFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * retrieve a single export
     */
    DefaultApi.prototype.getLogSearchExport = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSearchExportRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get the download link for an existing log search export
     */
    DefaultApi.prototype.getLogSearchExportDownloadRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSearchExportDownload.');
                        }
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling getLogSearchExportDownload.');
                        }
                        if (requestParameters.exportId === null || requestParameters.exportId === undefined) {
                            throw new runtime.RequiredError('exportId', 'Required parameter requestParameters.exportId was null or undefined when calling getLogSearchExportDownload.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/{requestId}/exports/{exportId}/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters.requestId))).replace("{".concat("exportId", "}"), encodeURIComponent(String(requestParameters.exportId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogSearchExportDownloadFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the download link for an existing log search export
     */
    DefaultApi.prototype.getLogSearchExportDownload = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSearchExportDownloadRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get details for an existing log search request
     */
    DefaultApi.prototype.getLogSearchRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSearchRequest.');
                        }
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling getLogSearchRequest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/{requestId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters.requestId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LogSearchRequestDetailsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get details for an existing log search request
     */
    DefaultApi.prototype.getLogSearchRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSearchRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * returns a list of existing log search requests
     */
    DefaultApi.prototype.getLogSearchRequestsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSearchRequests.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.LogSearchRequestFromJSON); })];
                }
            });
        });
    };
    /**
     * returns a list of existing log search requests
     */
    DefaultApi.prototype.getLogSearchRequests = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSearchRequestsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get results (logs) for an existing log search request
     */
    DefaultApi.prototype.getLogSearchResultsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSearchResults.');
                        }
                        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
                            throw new runtime.RequiredError('requestId', 'Required parameter requestParameters.requestId was null or undefined when calling getLogSearchResults.');
                        }
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getLogSearchResults.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/logsearch/{requestId}/results".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters.requestId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.LogSearchResultFromJSON); })];
                }
            });
        });
    };
    /**
     * get results (logs) for an existing log search request
     */
    DefaultApi.prototype.getLogSearchResults = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSearchResultsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves a list of system generated/reserved tags
     */
    DefaultApi.prototype.getLogSourceSystemTagsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSourceSystemTags.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/log-sources/system-tags".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Retrieves a list of system generated/reserved tags
     */
    DefaultApi.prototype.getLogSourceSystemTags = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSourceSystemTagsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves the list of existing log sources
     */
    DefaultApi.prototype.getLogSourcesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getLogSources.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/log-sources".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.LogSourceFromJSON); })];
                }
            });
        });
    };
    /**
     * Retrieves the list of existing log sources
     */
    DefaultApi.prototype.getLogSources = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogSourcesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getModelGroupRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.group === null || requestParameters.group === undefined) {
                            throw new runtime.RequiredError('group', 'Required parameter requestParameters.group was null or undefined when calling getModelGroup.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/groups/{group}".replace("{".concat("group", "}"), encodeURIComponent(String(requestParameters.group))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ModelGroupFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getModelGroup = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModelGroupRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getModelsFromGroupRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.group === null || requestParameters.group === undefined) {
                            throw new runtime.RequiredError('group', 'Required parameter requestParameters.group was null or undefined when calling getModelsFromGroup.');
                        }
                        if (requestParameters.modelType === null || requestParameters.modelType === undefined) {
                            throw new runtime.RequiredError('modelType', 'Required parameter requestParameters.modelType was null or undefined when calling getModelsFromGroup.');
                        }
                        queryParameters = {};
                        if (requestParameters.modelType !== undefined) {
                            queryParameters['modelType'] = requestParameters.modelType;
                        }
                        if (requestParameters.deploymentType !== undefined) {
                            queryParameters['deploymentType'] = requestParameters.deploymentType;
                        }
                        if (requestParameters.transceiverType !== undefined) {
                            queryParameters['transceiverType'] = requestParameters.transceiverType;
                        }
                        if (requestParameters.rackmounts !== undefined) {
                            queryParameters['rackmounts'] = requestParameters.rackmounts;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/groups/{group}/models".replace("{".concat("group", "}"), encodeURIComponent(String(requestParameters.group))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ModelFromJSON); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getModelsFromGroup = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getModelsFromGroupRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Observation Pipeline API. When To and From are excluded the default period is 7 days.
     */
    DefaultApi.prototype.getObservationPipelineDetailsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getObservationPipelineDetails.');
                        }
                        if (requestParameters.start === null || requestParameters.start === undefined) {
                            throw new runtime.RequiredError('start', 'Required parameter requestParameters.start was null or undefined when calling getObservationPipelineDetails.');
                        }
                        if (requestParameters.end === null || requestParameters.end === undefined) {
                            throw new runtime.RequiredError('end', 'Required parameter requestParameters.end was null or undefined when calling getObservationPipelineDetails.');
                        }
                        queryParameters = {};
                        if (requestParameters.start !== undefined) {
                            queryParameters['start'] = requestParameters.start;
                        }
                        if (requestParameters.end !== undefined) {
                            queryParameters['end'] = requestParameters.end;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/pipeline-details".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ObservationPipelineDetailsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Observation Pipeline API. When To and From are excluded the default period is 7 days.
     */
    DefaultApi.prototype.getObservationPipelineDetails = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getObservationPipelineDetailsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getOnboardingTeamContactsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOnboardingTeamContacts.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/onboarding-team-contacts".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OnboardingTeamContactsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getOnboardingTeamContacts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOnboardingTeamContactsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the details for the Contact
     */
    DefaultApi.prototype.getOrgContactDetailsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrgContactDetails.');
                        }
                        if (requestParameters.contactId === null || requestParameters.contactId === undefined) {
                            throw new runtime.RequiredError('contactId', 'Required parameter requestParameters.contactId was null or undefined when calling getOrgContactDetails.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/contacts/{contactId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("contactId", "}"), encodeURIComponent(String(requestParameters.contactId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationContactFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the details for the Contact
     */
    DefaultApi.prototype.getOrgContactDetails = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrgContactDetailsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the contact details for the Organization
     */
    DefaultApi.prototype.getOrgContactsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrgContacts.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/contacts".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationContactsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the contact details for the Organization
     */
    DefaultApi.prototype.getOrgContacts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrgContactsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Organization API
     */
    DefaultApi.prototype.getOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrganization.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Organization API
     */
    DefaultApi.prototype.getOrganization = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get sensors for the given site
     */
    DefaultApi.prototype.getOrganizationSiteSensorsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrganizationSiteSensors.');
                        }
                        if (requestParameters.siteUUID === null || requestParameters.siteUUID === undefined) {
                            throw new runtime.RequiredError('siteUUID', 'Required parameter requestParameters.siteUUID was null or undefined when calling getOrganizationSiteSensors.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/sites/{siteUUID}/sensors".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("siteUUID", "}"), encodeURIComponent(String(requestParameters.siteUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SensorProfileFromJSON); })];
                }
            });
        });
    };
    /**
     * Get sensors for the given site
     */
    DefaultApi.prototype.getOrganizationSiteSensors = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationSiteSensorsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a specific site
     */
    DefaultApi.prototype.getOrganizationSiteV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrganizationSiteV2.');
                        }
                        if (requestParameters.siteUUID === null || requestParameters.siteUUID === undefined) {
                            throw new runtime.RequiredError('siteUUID', 'Required parameter requestParameters.siteUUID was null or undefined when calling getOrganizationSiteV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/sites/{siteUUID}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("siteUUID", "}"), encodeURIComponent(String(requestParameters.siteUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationSiteV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a specific site
     */
    DefaultApi.prototype.getOrganizationSiteV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationSiteV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all sites for a customer
     */
    DefaultApi.prototype.getOrganizationSitesV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrganizationSitesV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/sites".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.OrganizationSiteV2FromJSON); })];
                }
            });
        });
    };
    /**
     * Get all sites for a customer
     */
    DefaultApi.prototype.getOrganizationSitesV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationSitesV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getPurchasedCloudSensorVendorsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPurchasedCloudSensorVendors.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/purchased-cloud-sensor-vendors".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getPurchasedCloudSensorVendors = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPurchasedCloudSensorVendorsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * this endpoint is a proxy to Query Broker with spec https://github.com/rtkwlf/querybroker/blob/9b38f2ef4fa9041b6990592bd50841461e0353db/api_spec.yaml. It is thus valid to use a QB API client that is configured to point at a Rendall deployment. Rendall will proxy the request directly to QueryBroker. Authorization happens in query broker for this endpoint.
     */
    DefaultApi.prototype.getQueryBrokerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reverseProxyPath === null || requestParameters.reverseProxyPath === undefined) {
                            throw new runtime.RequiredError('reverseProxyPath', 'Required parameter requestParameters.reverseProxyPath was null or undefined when calling getQueryBroker.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/query/{path:.+}".replace("{".concat("reverseProxyPath", "}"), encodeURIComponent(String(requestParameters.reverseProxyPath))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * this endpoint is a proxy to Query Broker with spec https://github.com/rtkwlf/querybroker/blob/9b38f2ef4fa9041b6990592bd50841461e0353db/api_spec.yaml. It is thus valid to use a QB API client that is configured to point at a Rendall deployment. Rendall will proxy the request directly to QueryBroker. Authorization happens in query broker for this endpoint.
     */
    DefaultApi.prototype.getQueryBroker = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getQueryBrokerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get reboot schedule of the sensor
     */
    DefaultApi.prototype.getRebootScheduleInfoBySerialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRebootScheduleInfoBySerial.');
                        }
                        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
                            throw new runtime.RequiredError('serialNumber', 'Required parameter requestParameters.serialNumber was null or undefined when calling getRebootScheduleInfoBySerial.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/ssc/reboot_schedule/{SerialNumber}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("SerialNumber", "}"), encodeURIComponent(String(requestParameters.serialNumber))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RebootScheduleInfoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get reboot schedule of the sensor
     */
    DefaultApi.prototype.getRebootScheduleInfoBySerial = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRebootScheduleInfoBySerialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get data for the pre defined query.
     */
    DefaultApi.prototype.getReportDataByQueryIDRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReportDataByQueryID.');
                        }
                        if (requestParameters.queryId === null || requestParameters.queryId === undefined) {
                            throw new runtime.RequiredError('queryId', 'Required parameter requestParameters.queryId was null or undefined when calling getReportDataByQueryID.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/report-data/{queryId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("queryId", "}"), encodeURIComponent(String(requestParameters.queryId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get data for the pre defined query.
     */
    DefaultApi.prototype.getReportDataByQueryID = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReportDataByQueryIDRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Download report
     */
    DefaultApi.prototype.getReportURLRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReportURL.');
                        }
                        if (requestParameters.reportId === null || requestParameters.reportId === undefined) {
                            throw new runtime.RequiredError('reportId', 'Required parameter requestParameters.reportId was null or undefined when calling getReportURL.');
                        }
                        queryParameters = {};
                        if (requestParameters.contentDisposition !== undefined) {
                            queryParameters['contentDisposition'] = requestParameters.contentDisposition;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/reports/{reportId}/download".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("reportId", "}"), encodeURIComponent(String(requestParameters.reportId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ReportURLFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Download report
     */
    DefaultApi.prototype.getReportURL = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReportURLRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get reports
     */
    DefaultApi.prototype.getReportsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReports.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.title !== undefined) {
                            queryParameters['title'] = requestParameters.title;
                        }
                        if (requestParameters.sentDate !== undefined) {
                            queryParameters['sentDate'] = requestParameters.sentDate;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/reports".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ReportsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get reports
     */
    DefaultApi.prototype.getReports = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReportsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get the current retention period for the customer in days
     */
    DefaultApi.prototype.getRetentionPolicyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRetentionPolicy.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/retention".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RetentionPolicyFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the current retention period for the customer in days
     */
    DefaultApi.prototype.getRetentionPolicy = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRetentionPolicyRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Risk Score Details API
     */
    DefaultApi.prototype.getRiskScoreDetailsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRiskScoreDetails.');
                        }
                        queryParameters = {};
                        if (requestParameters.window !== undefined) {
                            queryParameters['window'] = requestParameters.window;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/risk-score-details".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RiskScoreDetailsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Risk Score Details API
     */
    DefaultApi.prototype.getRiskScoreDetails = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRiskScoreDetailsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScanSchedulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScanSchedules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SchedulePageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScanSchedules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScanSchedulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerDetailsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerDetails.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getScannerDetails.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scanners/{scannerId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScannerDetailsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerDetails = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerDetailsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns job issues of a particular scanner
     */
    DefaultApi.prototype.getScannerJobsIssuesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerJobsIssues.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getScannerJobsIssues.');
                        }
                        if (requestParameters.after === null || requestParameters.after === undefined) {
                            throw new runtime.RequiredError('after', 'Required parameter requestParameters.after was null or undefined when calling getScannerJobsIssues.');
                        }
                        queryParameters = {};
                        if (requestParameters.after !== undefined) {
                            queryParameters['after'] = requestParameters.after.toISOString();
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scanners/{scannerId}/jobs/issues".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ScannerJobIssueFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns job issues of a particular scanner
     */
    DefaultApi.prototype.getScannerJobsIssues = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerJobsIssuesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the license utilization/quotas
     */
    DefaultApi.prototype.getScannerLicenseUsageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerLicenseUsage.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scanner-license-usage".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.LicenseUsageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the license utilization/quotas
     */
    DefaultApi.prototype.getScannerLicenseUsage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerLicenseUsageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerPageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerPage.');
                        }
                        queryParameters = {};
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.version !== undefined) {
                            queryParameters['version'] = requestParameters.version;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scanners".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScannerPageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerPage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerPageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerProfileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerProfile.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getScannerProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/scanners/{scannerId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScannerProfileFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerProfile = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerProfileRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get scan credentials for scanner
     */
    DefaultApi.prototype.getScannerScanCredentialsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerScanCredentials.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getScannerScanCredentials.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-credentials".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CredentialPageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get scan credentials for scanner
     */
    DefaultApi.prototype.getScannerScanCredentials = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerScanCredentialsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the queue of scans for a scanner
     */
    DefaultApi.prototype.getScannerScanQueueRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerScanQueue.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getScannerScanQueue.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-queue".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScanQueueFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the queue of scans for a scanner
     */
    DefaultApi.prototype.getScannerScanQueue = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerScanQueueRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get scan schedules for scanner
     */
    DefaultApi.prototype.getScannerScanSchedulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerScanSchedules.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling getScannerScanSchedules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-schedules".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SchedulePageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get scan schedules for scanner
     */
    DefaultApi.prototype.getScannerScanSchedules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerScanSchedulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerSummaryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScannerSummary.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scanner-summary".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScannerSummaryFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getScannerSummary = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScannerSummaryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get scheduled reports
     */
    DefaultApi.prototype.getScheduledReportsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getScheduledReports.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.title !== undefined) {
                            queryParameters['title'] = requestParameters.title;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scheduled-reports".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ScheduledReportsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get scheduled reports
     */
    DefaultApi.prototype.getScheduledReports = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getScheduledReportsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the Cloud Credential schema from the Console.
     */
    DefaultApi.prototype.getSecretsSchemaRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSecretsSchema.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/secrets-schema".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return runtime.mapValues(jsonValue, models_1.CredentialSchemaFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns the Cloud Credential schema from the Console.
     */
    DefaultApi.prototype.getSecretsSchema = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSecretsSchemaRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSensor.');
                        }
                        if (requestParameters.sensorId === null || requestParameters.sensorId === undefined) {
                            throw new runtime.RequiredError('sensorId', 'Required parameter requestParameters.sensorId was null or undefined when calling getSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensors/{sensorId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("sensorId", "}"), encodeURIComponent(String(requestParameters.sensorId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SensorFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getSensorPageRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSensorPage.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.product !== undefined) {
                            queryParameters['product'] = requestParameters.product;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensors".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SensorPageFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getSensorPage = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSensorPageRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getSensorSummaryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSensorSummary.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensor-summary".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SensorSummaryFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getSensorSummary = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSensorSummaryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Service Endpoints API; Exposes publicly available information and is therefore not authorized
     */
    DefaultApi.prototype.getServiceEndpointsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.window !== undefined) {
                            queryParameters['window'] = requestParameters.window;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/service-endpoints",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ServiceEndpointsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Service Endpoints API; Exposes publicly available information and is therefore not authorized
     */
    DefaultApi.prototype.getServiceEndpoints = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getServiceEndpointsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the possible shipping contacts that the user can choose from
     */
    DefaultApi.prototype.getShippingContactsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getShippingContacts.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/shipping-contacts".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ShippingContactsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the possible shipping contacts that the user can choose from
     */
    DefaultApi.prototype.getShippingContacts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getShippingContactsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * list subscriptions for an organization
     */
    DefaultApi.prototype.getSubscriptionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSubscriptions.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/subscriptions".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SubscriptionDetailFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * list subscriptions for an organization
     */
    DefaultApi.prototype.getSubscriptions = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSubscriptionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve the dictionary of customer suppression configuration rules
     */
    DefaultApi.prototype.getSuppressionConfigurationRulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSuppressionConfigurationRules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/configuration-rules/suppression".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return runtime.mapValues(jsonValue, models_1.SuppressionConfigurationRuleFromJSON); })];
                }
            });
        });
    };
    /**
     * Retrieve the dictionary of customer suppression configuration rules
     */
    DefaultApi.prototype.getSuppressionConfigurationRules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSuppressionConfigurationRulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get the complete details for an individual ticket
     */
    DefaultApi.prototype.getTicketV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTicketV2.');
                        }
                        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
                            throw new runtime.RequiredError('ticketId', 'Required parameter requestParameters.ticketId was null or undefined when calling getTicketV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/tickets/{ticketId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("ticketId", "}"), encodeURIComponent(String(requestParameters.ticketId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TicketWithCommentsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the complete details for an individual ticket
     */
    DefaultApi.prototype.getTicketV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTicketV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * list all upgrades by organizationId
     */
    DefaultApi.prototype.getUpgradesInfoByCustomerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUpgradesInfoByCustomer.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/ssc/upgrade-info".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.SSCUpdateInfoFromJSON); })];
                }
            });
        });
    };
    /**
     * list all upgrades by organizationId
     */
    DefaultApi.prototype.getUpgradesInfoByCustomer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUpgradesInfoByCustomerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * list all upgrades by SerialNumber for a specific organizationId
     */
    DefaultApi.prototype.getUpgradesInfoByCustomerSerialNumberRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUpgradesInfoByCustomerSerialNumber.');
                        }
                        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
                            throw new runtime.RequiredError('serialNumber', 'Required parameter requestParameters.serialNumber was null or undefined when calling getUpgradesInfoByCustomerSerialNumber.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/ssc/{SerialNumber}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("SerialNumber", "}"), encodeURIComponent(String(requestParameters.serialNumber))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SSCUpdateInfoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * list all upgrades by SerialNumber for a specific organizationId
     */
    DefaultApi.prototype.getUpgradesInfoByCustomerSerialNumber = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUpgradesInfoByCustomerSerialNumberRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns information about current user. Doesn\'t return organization information and is therefore not authorized to an organization.
     */
    DefaultApi.prototype.getUserInfoRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/user",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UserFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns information about current user. Doesn\'t return organization information and is therefore not authorized to an organization.
     */
    DefaultApi.prototype.getUserInfo = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserInfoRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getUsersListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsersList.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/users".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UsersResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.getUsersList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUsersListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Installs a sensor identified by its serial number.
     * Installs a sensor
     */
    DefaultApi.prototype.installSensorRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling installSensor.');
                        }
                        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
                            throw new runtime.RequiredError('serialNumber', 'Required parameter requestParameters.serialNumber was null or undefined when calling installSensor.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensor/{serialNumber}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("serialNumber", "}"), encodeURIComponent(String(requestParameters.serialNumber))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Installs a sensor identified by its serial number.
     * Installs a sensor
     */
    DefaultApi.prototype.installSensor = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.installSensorRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * gets a list of all tickets that the user has access to
     */
    DefaultApi.prototype.listTicketsV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listTicketsV2.');
                        }
                        queryParameters = {};
                        if (requestParameters.includeInactive !== undefined) {
                            queryParameters['include_inactive'] = requestParameters.includeInactive;
                        }
                        if (requestParameters.after !== undefined) {
                            queryParameters['after'] = requestParameters.after.toISOString();
                        }
                        if (requestParameters.before !== undefined) {
                            queryParameters['before'] = requestParameters.before.toISOString();
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/tickets".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TicketListFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * gets a list of all tickets that the user has access to
     */
    DefaultApi.prototype.listTicketsV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listTicketsV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * this endpoint is a proxy to Query Broker with spec https://github.com/rtkwlf/querybroker/blob/9b38f2ef4fa9041b6990592bd50841461e0353db/api_spec.yaml. It is thus valid to use a QB API client that is configured to point at a Rendall deployment. Rendall will proxy the request directly to QueryBroker. Authorization happens in query broker for this endpoint.
     */
    DefaultApi.prototype.postQueryBrokerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reverseProxyPath === null || requestParameters.reverseProxyPath === undefined) {
                            throw new runtime.RequiredError('reverseProxyPath', 'Required parameter requestParameters.reverseProxyPath was null or undefined when calling postQueryBroker.');
                        }
                        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
                            throw new runtime.RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling postQueryBroker.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/query/{path:.+}".replace("{".concat("reverseProxyPath", "}"), encodeURIComponent(String(requestParameters.reverseProxyPath))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.requestBody,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * this endpoint is a proxy to Query Broker with spec https://github.com/rtkwlf/querybroker/blob/9b38f2ef4fa9041b6990592bd50841461e0353db/api_spec.yaml. It is thus valid to use a QB API client that is configured to point at a Rendall deployment. Rendall will proxy the request directly to QueryBroker. Authorization happens in query broker for this endpoint.
     */
    DefaultApi.prototype.postQueryBroker = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postQueryBrokerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create reboot schedule for the sensor
     */
    DefaultApi.prototype.postRebootScheduleInfoBySerialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling postRebootScheduleInfoBySerial.');
                        }
                        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
                            throw new runtime.RequiredError('serialNumber', 'Required parameter requestParameters.serialNumber was null or undefined when calling postRebootScheduleInfoBySerial.');
                        }
                        if (requestParameters.sSCRebootRescheduleRequest === null || requestParameters.sSCRebootRescheduleRequest === undefined) {
                            throw new runtime.RequiredError('sSCRebootRescheduleRequest', 'Required parameter requestParameters.sSCRebootRescheduleRequest was null or undefined when calling postRebootScheduleInfoBySerial.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/ssc/reboot_schedule/{SerialNumber}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("SerialNumber", "}"), encodeURIComponent(String(requestParameters.serialNumber))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SSCRebootRescheduleRequestToJSON)(requestParameters.sSCRebootRescheduleRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OKResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create reboot schedule for the sensor
     */
    DefaultApi.prototype.postRebootScheduleInfoBySerial = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRebootScheduleInfoBySerialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Handles a request to update the scout customer configuration associated with the customerUUID
     * Handles a request to update the scout customer configuration associated with the customerUUID
     */
    DefaultApi.prototype.putAgentCustomerConfigurationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling putAgentCustomerConfiguration.');
                        }
                        if (requestParameters.createUpdateAgentCustomerConfigurationRequest === null || requestParameters.createUpdateAgentCustomerConfigurationRequest === undefined) {
                            throw new runtime.RequiredError('createUpdateAgentCustomerConfigurationRequest', 'Required parameter requestParameters.createUpdateAgentCustomerConfigurationRequest was null or undefined when calling putAgentCustomerConfiguration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/configuration".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateUpdateAgentCustomerConfigurationRequestToJSON)(requestParameters.createUpdateAgentCustomerConfigurationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentCustomerConfigurationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Handles a request to update the scout customer configuration associated with the customerUUID
     * Handles a request to update the scout customer configuration associated with the customerUUID
     */
    DefaultApi.prototype.putAgentCustomerConfiguration = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putAgentCustomerConfigurationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Handles a request to update the V2 scout customer configuration associated with the customerUUID
     * Handles a request to update the V2 scout customer configuration associated with the customerUUID
     */
    DefaultApi.prototype.putAgentCustomerConfigurationV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling putAgentCustomerConfigurationV2.');
                        }
                        if (requestParameters.agentCustomerConfigurationV2 === null || requestParameters.agentCustomerConfigurationV2 === undefined) {
                            throw new runtime.RequiredError('agentCustomerConfigurationV2', 'Required parameter requestParameters.agentCustomerConfigurationV2 was null or undefined when calling putAgentCustomerConfigurationV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/agent/configuration".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.AgentCustomerConfigurationV2ToJSON)(requestParameters.agentCustomerConfigurationV2),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentCustomerConfigurationV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Handles a request to update the V2 scout customer configuration associated with the customerUUID
     * Handles a request to update the V2 scout customer configuration associated with the customerUUID
     */
    DefaultApi.prototype.putAgentCustomerConfigurationV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putAgentCustomerConfigurationV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update request to the scout customer configuration associated with the customerUUID for internal users
     * Handles a request to update the scout customer internal configuration associated with the customerUUID
     */
    DefaultApi.prototype.putAgentCustomerInternalConfigurationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling putAgentCustomerInternalConfiguration.');
                        }
                        if (requestParameters.updateAgentCustomerInternalConfigurationRequest === null || requestParameters.updateAgentCustomerInternalConfigurationRequest === undefined) {
                            throw new runtime.RequiredError('updateAgentCustomerInternalConfigurationRequest', 'Required parameter requestParameters.updateAgentCustomerInternalConfigurationRequest was null or undefined when calling putAgentCustomerInternalConfiguration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/configuration/internal".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.UpdateAgentCustomerInternalConfigurationRequestToJSON)(requestParameters.updateAgentCustomerInternalConfigurationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UpdateAgentCustomerInternalConfigurationRequestFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update request to the scout customer configuration associated with the customerUUID for internal users
     * Handles a request to update the scout customer internal configuration associated with the customerUUID
     */
    DefaultApi.prototype.putAgentCustomerInternalConfiguration = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putAgentCustomerInternalConfigurationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the containment allowlist for the specified customer
     */
    DefaultApi.prototype.putCustomerContainmentAllowListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling putCustomerContainmentAllowList.');
                        }
                        if (requestParameters.agentContainmentAllowListV1 === null || requestParameters.agentContainmentAllowListV1 === undefined) {
                            throw new runtime.RequiredError('agentContainmentAllowListV1', 'Required parameter requestParameters.agentContainmentAllowListV1 was null or undefined when calling putCustomerContainmentAllowList.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/containment/allowlist".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.AgentContainmentAllowListV1ToJSON)(requestParameters.agentContainmentAllowListV1),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.AgentContainmentAllowListV1FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the containment allowlist for the specified customer
     */
    DefaultApi.prototype.putCustomerContainmentAllowList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putCustomerContainmentAllowListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.putCustomerCredentialRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling putCustomerCredential.');
                        }
                        if (requestParameters.deploymentId === null || requestParameters.deploymentId === undefined) {
                            throw new runtime.RequiredError('deploymentId', 'Required parameter requestParameters.deploymentId was null or undefined when calling putCustomerCredential.');
                        }
                        if (requestParameters.createCloudSensorInput === null || requestParameters.createCloudSensorInput === undefined) {
                            throw new runtime.RequiredError('createCloudSensorInput', 'Required parameter requestParameters.createCloudSensorInput was null or undefined when calling putCustomerCredential.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/customer-credential/{deploymentId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("deploymentId", "}"), encodeURIComponent(String(requestParameters.deploymentId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateCloudSensorInputToJSON)(requestParameters.createCloudSensorInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CredentialFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.putCustomerCredential = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putCustomerCredentialRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Middleware to execute Querybroker with some extra validation.
     */
    DefaultApi.prototype.queryAnalyzedLogsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling queryAnalyzedLogs.');
                        }
                        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
                            throw new runtime.RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling queryAnalyzedLogs.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xAwSource !== undefined && requestParameters.xAwSource !== null) {
                            headerParameters['X-Aw-Source'] = String(requestParameters.xAwSource);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/analyzed-logs".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.requestBody,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Middleware to execute Querybroker with some extra validation.
     */
    DefaultApi.prototype.queryAnalyzedLogs = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryAnalyzedLogsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Middleware to get a record from a ch_observations source.
     */
    DefaultApi.prototype.queryAnalyzedLogsByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling queryAnalyzedLogsById.');
                        }
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling queryAnalyzedLogsById.');
                        }
                        queryParameters = {};
                        if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/analyzed-logs/{id}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Middleware to get a record from a ch_observations source.
     */
    DefaultApi.prototype.queryAnalyzedLogsById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryAnalyzedLogsByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * For querying analyzed logs for DE subscribed customers with additional query validations.
     */
    DefaultApi.prototype.queryDataExplorerAnalyzedLogsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling queryDataExplorerAnalyzedLogs.');
                        }
                        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
                            throw new runtime.RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling queryDataExplorerAnalyzedLogs.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/data-explorer/analyzed-logs".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.requestBody,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * For querying analyzed logs for DE subscribed customers with additional query validations.
     */
    DefaultApi.prototype.queryDataExplorerAnalyzedLogs = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryDataExplorerAnalyzedLogsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Trigger a Reboot of the SSC ASAP
     */
    DefaultApi.prototype.rebootNowRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling rebootNow.');
                        }
                        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
                            throw new runtime.RequiredError('serialNumber', 'Required parameter requestParameters.serialNumber was null or undefined when calling rebootNow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/ssc/reboot/{SerialNumber}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("SerialNumber", "}"), encodeURIComponent(String(requestParameters.serialNumber))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OKResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Trigger a Reboot of the SSC ASAP
     */
    DefaultApi.prototype.rebootNow = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rebootNowRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Rotate the ACTIVE secrets associated with a deployment
     */
    DefaultApi.prototype.rotateCustomerCredentialSecretsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling rotateCustomerCredentialSecrets.');
                        }
                        if (requestParameters.deploymentId === null || requestParameters.deploymentId === undefined) {
                            throw new runtime.RequiredError('deploymentId', 'Required parameter requestParameters.deploymentId was null or undefined when calling rotateCustomerCredentialSecrets.');
                        }
                        queryParameters = {};
                        if (requestParameters.revoke !== undefined) {
                            queryParameters['revoke'] = requestParameters.revoke;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/customer-credential/{deploymentId}/rotate-secrets".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("deploymentId", "}"), encodeURIComponent(String(requestParameters.deploymentId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Rotate the ACTIVE secrets associated with a deployment
     */
    DefaultApi.prototype.rotateCustomerCredentialSecrets = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rotateCustomerCredentialSecretsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Request to initiate a scan
     */
    DefaultApi.prototype.scanAgentNowRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling scanAgentNow.');
                        }
                        if (requestParameters.scanAgentNowInput === null || requestParameters.scanAgentNowInput === undefined) {
                            throw new runtime.RequiredError('scanAgentNowInput', 'Required parameter requestParameters.scanAgentNowInput was null or undefined when calling scanAgentNow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/scan-schedules/agent/scan".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ScanAgentNowInputToJSON)(requestParameters.scanAgentNowInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Request to initiate a scan
     */
    DefaultApi.prototype.scanAgentNow = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.scanAgentNowRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rescan supplied EVA assets
     */
    DefaultApi.prototype.scanEvaNowRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling scanEvaNow.');
                        }
                        if (requestParameters.scanEvaNowInput === null || requestParameters.scanEvaNowInput === undefined) {
                            throw new runtime.RequiredError('scanEvaNowInput', 'Required parameter requestParameters.scanEvaNowInput was null or undefined when calling scanEvaNow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/eva/scan".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ScanEvaNowInputToJSON)(requestParameters.scanEvaNowInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Rescan supplied EVA assets
     */
    DefaultApi.prototype.scanEvaNow = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.scanEvaNowRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Request to initiate a scan
     */
    DefaultApi.prototype.scanIvaNowRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling scanIvaNow.');
                        }
                        if (requestParameters.scanIvaNowInput === null || requestParameters.scanIvaNowInput === undefined) {
                            throw new runtime.RequiredError('scanIvaNowInput', 'Required parameter requestParameters.scanIvaNowInput was null or undefined when calling scanIvaNow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/scan".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ScanIvaNowInputToJSON)(requestParameters.scanIvaNowInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Request to initiate a scan
     */
    DefaultApi.prototype.scanIvaNow = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.scanIvaNowRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Enables or disables a batch of client-specific module assignments (atomically). New assignments will be created if they don\'t already exist.
     * Enables or disables a batch of module assignments based on the passed in client identifiers and flags
     */
    DefaultApi.prototype.setModuleAssignmentsEnabledRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling setModuleAssignmentsEnabled.');
                        }
                        if (requestParameters.moduleId === null || requestParameters.moduleId === undefined) {
                            throw new runtime.RequiredError('moduleId', 'Required parameter requestParameters.moduleId was null or undefined when calling setModuleAssignmentsEnabled.');
                        }
                        if (requestParameters.moduleAssignmentEnabledRequest === null || requestParameters.moduleAssignmentEnabledRequest === undefined) {
                            throw new runtime.RequiredError('moduleAssignmentEnabledRequest', 'Required parameter requestParameters.moduleAssignmentEnabledRequest was null or undefined when calling setModuleAssignmentsEnabled.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/agent/modules/{moduleId}/assignments/enabled".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("moduleId", "}"), encodeURIComponent(String(requestParameters.moduleId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.moduleAssignmentEnabledRequest.map(models_1.ModuleAssignmentEnabledRequestToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ModuleAssignmentFromJSON); })];
                }
            });
        });
    };
    /**
     * Enables or disables a batch of client-specific module assignments (atomically). New assignments will be created if they don\'t already exist.
     * Enables or disables a batch of module assignments based on the passed in client identifiers and flags
     */
    DefaultApi.prototype.setModuleAssignmentsEnabled = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setModuleAssignmentsEnabledRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Solve a ticket in Zendesk. If closing a ticket with the status \"new\", a comment must be provided. When adding a comment, the closure reason must also be provided. When adding an attachment, a comment must also be provided.
     */
    DefaultApi.prototype.solveTicketRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling solveTicket.');
                        }
                        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
                            throw new runtime.RequiredError('ticketId', 'Required parameter requestParameters.ticketId was null or undefined when calling solveTicket.');
                        }
                        if (requestParameters.solveTicketInput === null || requestParameters.solveTicketInput === undefined) {
                            throw new runtime.RequiredError('solveTicketInput', 'Required parameter requestParameters.solveTicketInput was null or undefined when calling solveTicket.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/tickets/{ticketId}/solve".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("ticketId", "}"), encodeURIComponent(String(requestParameters.ticketId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SolveTicketInputToJSON)(requestParameters.solveTicketInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TicketWithCommentsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Solve a ticket in Zendesk. If closing a ticket with the status \"new\", a comment must be provided. When adding a comment, the closure reason must also be provided. When adding an attachment, a comment must also be provided.
     */
    DefaultApi.prototype.solveTicket = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.solveTicketRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update configuration rules
     */
    DefaultApi.prototype.updateConfigurationRulesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateConfigurationRules.');
                        }
                        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
                            throw new runtime.RequiredError('alertId', 'Required parameter requestParameters.alertId was null or undefined when calling updateConfigurationRules.');
                        }
                        if (requestParameters.configRequestBody === null || requestParameters.configRequestBody === undefined) {
                            throw new runtime.RequiredError('configRequestBody', 'Required parameter requestParameters.configRequestBody was null or undefined when calling updateConfigurationRules.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/configuration-rules/alert/{alertId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("alertId", "}"), encodeURIComponent(String(requestParameters.alertId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ConfigRequestBodyToJSON)(requestParameters.configRequestBody),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ConfigRequestBodyFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update configuration rules
     */
    DefaultApi.prototype.updateConfigurationRules = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateConfigurationRulesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a credential scan
     */
    DefaultApi.prototype.updateIvaCredentialScanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateIvaCredentialScan.');
                        }
                        if (requestParameters.scannerId === null || requestParameters.scannerId === undefined) {
                            throw new runtime.RequiredError('scannerId', 'Required parameter requestParameters.scannerId was null or undefined when calling updateIvaCredentialScan.');
                        }
                        if (requestParameters.credentialId === null || requestParameters.credentialId === undefined) {
                            throw new runtime.RequiredError('credentialId', 'Required parameter requestParameters.credentialId was null or undefined when calling updateIvaCredentialScan.');
                        }
                        if (requestParameters.credentialInput === null || requestParameters.credentialInput === undefined) {
                            throw new runtime.RequiredError('credentialInput', 'Required parameter requestParameters.credentialInput was null or undefined when calling updateIvaCredentialScan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/iva/{scannerId}/scan-credentials/{credentialId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("scannerId", "}"), encodeURIComponent(String(requestParameters.scannerId))).replace("{".concat("credentialId", "}"), encodeURIComponent(String(requestParameters.credentialId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CredentialInputToJSON)(requestParameters.credentialInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update a credential scan
     */
    DefaultApi.prototype.updateIvaCredentialScan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateIvaCredentialScanRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update an organization contact
     */
    DefaultApi.prototype.updateOrgContactRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateOrgContact.');
                        }
                        if (requestParameters.contactId === null || requestParameters.contactId === undefined) {
                            throw new runtime.RequiredError('contactId', 'Required parameter requestParameters.contactId was null or undefined when calling updateOrgContact.');
                        }
                        if (requestParameters.organizationContactInput === null || requestParameters.organizationContactInput === undefined) {
                            throw new runtime.RequiredError('organizationContactInput', 'Required parameter requestParameters.organizationContactInput was null or undefined when calling updateOrgContact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/contacts/{contactId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("contactId", "}"), encodeURIComponent(String(requestParameters.contactId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OrganizationContactInputToJSON)(requestParameters.organizationContactInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationContactFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an organization contact
     */
    DefaultApi.prototype.updateOrgContact = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrgContactRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a specific site
     */
    DefaultApi.prototype.updateOrganizationSiteV2Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateOrganizationSiteV2.');
                        }
                        if (requestParameters.siteUUID === null || requestParameters.siteUUID === undefined) {
                            throw new runtime.RequiredError('siteUUID', 'Required parameter requestParameters.siteUUID was null or undefined when calling updateOrganizationSiteV2.');
                        }
                        if (requestParameters.organizationSiteV2 === null || requestParameters.organizationSiteV2 === undefined) {
                            throw new runtime.RequiredError('organizationSiteV2', 'Required parameter requestParameters.organizationSiteV2 was null or undefined when calling updateOrganizationSiteV2.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v2/organizations/{organizationId}/sites/{siteUUID}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("siteUUID", "}"), encodeURIComponent(String(requestParameters.siteUUID))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OrganizationSiteV2ToJSON)(requestParameters.organizationSiteV2),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrganizationSiteV2FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a specific site
     */
    DefaultApi.prototype.updateOrganizationSiteV2 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganizationSiteV2Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.updateSensorProfileByUUIDRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateSensorProfileByUUID.');
                        }
                        if (requestParameters.profileUUID === null || requestParameters.profileUUID === undefined) {
                            throw new runtime.RequiredError('profileUUID', 'Required parameter requestParameters.profileUUID was null or undefined when calling updateSensorProfileByUUID.');
                        }
                        if (requestParameters.sensorProfile === null || requestParameters.sensorProfile === undefined) {
                            throw new runtime.RequiredError('sensorProfile', 'Required parameter requestParameters.sensorProfile was null or undefined when calling updateSensorProfileByUUID.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationId}/sensor-profiles/{profileUUID}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters.organizationId))).replace("{".concat("profileUUID", "}"), encodeURIComponent(String(requestParameters.profileUUID))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SensorProfileToJSON)(requestParameters.sensorProfile),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SensorProfileFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    DefaultApi.prototype.updateSensorProfileByUUID = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSensorProfileByUUIDRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Upload an attachment to the ticket. Attachment isn\'t linked to a specific organization until the ticket is created and therefore this endpoint isn\'t authorized.
     */
    DefaultApi.prototype.uploadZendeskAttachmentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.filename === null || requestParameters.filename === undefined) {
                            throw new runtime.RequiredError('filename', 'Required parameter requestParameters.filename was null or undefined when calling uploadZendeskAttachment.');
                        }
                        queryParameters = {};
                        if (requestParameters.filename !== undefined) {
                            queryParameters['filename'] = requestParameters.filename;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/octet-stream';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/uploads",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.body,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ZendeskUploadResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Upload an attachment to the ticket. Attachment isn\'t linked to a specific organization until the ticket is created and therefore this endpoint isn\'t authorized.
     */
    DefaultApi.prototype.uploadZendeskAttachment = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadZendeskAttachmentRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DefaultApi;
}(runtime.BaseAPI));
exports.DefaultApi = DefaultApi;
/**
 * @export
 */
exports.CreateDetectionsExportUseCaseEnum = {
    All: 'all',
    CveVulnerability: 'cve_vulnerability',
    SecureConfiguration: 'secure_configuration'
};
/**
 * @export
 */
exports.CreateDetectionsExportTechnologyEnum = {
    Agent: 'agent',
    Scanner: 'scanner',
    Eva: 'eva',
    Cspm: 'cspm',
    Nvd: 'nvd'
};
/**
 * @export
 */
exports.CreateDetectionsExportPlatformEnum = {
    Windows: 'windows',
    Linux: 'linux',
    Mac: 'mac',
    Aws: 'aws',
    Azure: 'azure',
    Other: 'other'
};
/**
 * @export
 */
exports.CreateDetectionsExportSeverityEnum = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Other: 'other'
};
/**
 * @export
 */
exports.CreateDetectionsExportCvesDetectionsEnum = {
    WithDetections: 'cves_with_detections',
    WithoutDetections: 'cves_without_detections',
    WithAndWithoutDetections: 'cves_with_and_without_detections'
};
/**
 * @export
 */
exports.CreateDetectionsExportSortByEnum = {
    Title: 'title',
    Source: 'source',
    DetectionId: 'detection_id',
    Technology: 'technology',
    Platform: 'platform',
    Severity: 'severity',
    Cvss: 'cvss',
    FirstPublished: 'first_published',
    LastModified: 'last_modified'
};
/**
 * @export
 */
exports.CreateDetectionsExportSortEnum = {
    Asc: 'asc',
    Desc: 'desc',
    None: 'none'
};
/**
 * @export
 */
exports.DownloadHyperVSensorSensorImageIdEnum = {
    Awnv100: 'vsensor_hyperv_awnv100',
    Awnv200: 'vsensor_hyperv_awnv200',
    Awnv1000: 'vsensor_hyperv_awnv1000'
};
/**
 * @export
 */
exports.GetAgentModulesStatusEnum = {
    Stable: 'stable',
    Prerelease: 'prerelease',
    Deprecated: 'deprecated'
};
/**
 * @export
 */
exports.GetAgentPageV2StatusEnum = {
    Online: 'online',
    Degraded: 'degraded',
    Offline: 'offline',
    Inactive: 'inactive',
    AllOffline: 'allOffline',
    Contained: 'contained'
};
/**
 * @export
 */
exports.GetAgentPageV2OsTypeEnum = {
    Windows: 'windows',
    Mac: 'mac',
    Linux: 'linux'
};
/**
 * @export
 */
exports.GetCloudSensorPageStatusEnum = {
    Healthy: 'healthy',
    Unhealthy: 'unhealthy',
    Disconnectpending: 'disconnectpending',
    Configpending: 'configpending',
    Pendingcustomerconfig: 'pendingcustomerconfig',
    Notavailable: 'notavailable',
    Notapplicable: 'notapplicable',
    Invalidcredentials: 'invalidcredentials'
};
/**
 * @export
 */
exports.GetDetectionPageUseCaseEnum = {
    All: 'all',
    CveVulnerability: 'cve_vulnerability',
    SecureConfiguration: 'secure_configuration'
};
/**
 * @export
 */
exports.GetDetectionPageTechnologyEnum = {
    Agent: 'agent',
    Scanner: 'scanner',
    Eva: 'eva',
    Cspm: 'cspm',
    Nvd: 'nvd'
};
/**
 * @export
 */
exports.GetDetectionPagePlatformEnum = {
    Windows: 'windows',
    Linux: 'linux',
    Mac: 'mac',
    Aws: 'aws',
    Azure: 'azure',
    Other: 'other'
};
/**
 * @export
 */
exports.GetDetectionPageSeverityEnum = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Other: 'other'
};
/**
 * @export
 */
exports.GetDetectionPageCvesDetectionsEnum = {
    WithDetections: 'cves_with_detections',
    WithoutDetections: 'cves_without_detections',
    WithAndWithoutDetections: 'cves_with_and_without_detections'
};
/**
 * @export
 */
exports.GetDetectionPageSortByEnum = {
    Title: 'title',
    Source: 'source',
    DetectionId: 'detection_id',
    Technology: 'technology',
    Platform: 'platform',
    Severity: 'severity',
    Cvss: 'cvss',
    FirstPublished: 'first_published',
    LastModified: 'last_modified'
};
/**
 * @export
 */
exports.GetDetectionPageSortEnum = {
    Asc: 'asc',
    Desc: 'desc',
    None: 'none'
};
/**
 * @export
 */
exports.GetReportDataByQueryIDQueryIdEnum = {
    MonthlyAlertHistory: 'monthly-alert-history',
    MonthlyInvestigationHistory: 'monthly-investigation-history',
    InvestigationBreakdownPastYear: 'investigation-breakdown-past-year',
    AlertBreakdownPastYear: 'alert-breakdown-past-year'
};
/**
 * @export
 */
exports.GetScannerPageStatusEnum = {
    Disconnected: 'disconnected',
    Degraded: 'degraded',
    AwaitingActivation: 'awaitingActivation',
    Scanning: 'scanning',
    Idle: 'idle',
    Connected: 'connected',
    NotAvailable: 'notAvailable'
};
/**
 * @export
 */
exports.GetScannerPageTypeEnum = {
    Physical: 'physical',
    Virtual: 'virtual'
};
/**
 * @export
 */
exports.GetSensorPageStatusEnum = {
    Unhealthy: 'unhealthy',
    Staged: 'staged',
    AwaitingActivation: 'awaitingActivation',
    Shipped: 'shipped',
    PreparingToShip: 'preparingToShip',
    Healthy: 'healthy'
};
/**
 * @export
 */
exports.GetSensorPageProductEnum = {
    Physical: 'physical',
    Virtual: 'virtual',
    Vlc: 'vlc'
};
